
export const id = {
  Meta: {
    home: {
      title: "Buat Undangan Digital Gratis 100% & Elegan | Elynk",
      description: "Bikin undangan digital gratis tanpa biaya di Elynk. Ratusan tema mewah, sebar otomatis ke WhatsApp, & fitur follow-up tamu. Cepat, mudah, dan kekinian!",
      keywords: [
        "undangan digital",
        "undangan online gratis",
        "elynk",
        "undangan pernikahan digital",
        "website undangan",
        "buku tamu digital",
        "amplop digital",
        "sebar wa otomatis"
      ]
    },
    price: {
      title: "Paket Harga Undangan Digital - Elynk.co",
      description: "Pilih paket harga terbaik untuk undangan digitalmu. Tersedia paket gratis selamanya dengan fitur lengkap dan sebar tanpa batas."
    },
    theme: {
      title: "Katalog Tema Undangan Digital Elegan, Mewah & Modern | Elynk",
      description: "Pilih ratusan desain undangan digital estetik untuk pernikahan, khitanan, atau acara lainnya. Responsif di HP, loading cepat, dan desain selalu update."
    },
    feature: {
      title: "Fitur Lengkap Undangan Digital | Elynk",
      description: "Fitur terlengkap mulai dari sebar WhatsApp otomatis, QR code buku tamu, amplop digital, hingga custom RSVP fleksibel."
    },
    login: {
      title: "Masuk ke Akun Anda | Elynk",
      description: "Masuk ke dashboard Elynk untuk mengelola dan membuat undangan digital impian Anda."
    },
    register: {
      title: "Daftar Akun Baru 100% Gratis | Elynk",
      description: "Buat akun Elynk sekarang dan mulai buat undangan digital profesional tanpa biaya."
    }
  },
  Common: {
    opsi: "Opsi",
    atau: "atau",
    sebelumnya: "Sebelumnya",
    kelola: "Kelola",
    filter: "Filter",
    status: "Status",
    jenis_acara: "Jenis Acara",
    cari: "Cari",
    batal: "Batal",
    simpan: "Simpan",
    loading: "Memuat...",
    tidak_ada_hasil: "Tidak ada hasil ditemukan",
    pilih: "Pilih",
    tidak_ada_opsi: "Tidak ada opsi",
    masukkan: "Masukkan",
    tutup: "Tutup",
    edit: "Edit",
    hapus: "Hapus",
    tambah: "Tambah",
    lihat: "Lihat",
    semua: "Semua",
    terbaru: "Terbaru",
    terlama: "Terlama",
    nama_az: "Nama A-Z",
    pulihkan: "Pulihkan",
    arsipkan: "Arsipkan",
    reset_filter: "Reset Filter",
    reset: "Reset",
    detail: "Detail",
    preview: "Preview",
    kembali: "Kembali",
    titip_hadiah: "Titip Hadiah",
    menyimpan: "Menyimpan...",
    simpan_perubahan: "Simpan Perubahan",
    terdapat_kesalahan: "Terdapat kesalahan",
    muat_lebih_banyak: "Muat Lebih Banyak",
    tidak_ada_data: "Tidak ada data tersedia",
    tindakan: "Tindakan",
    aksi: "Aksi",
    pemilik_acara: "Pemilik Acara",
    memuat_ucapan: "Memuat ucapan...",
    total_ucapan: "Total Ucapan",
    tamu_undangan: "Tamu Undangan",
    total_ucapan_with_count: "Ucapan ({total} Total Ucapan)",
    ucapan: "Ucapan & Doa",
    total_ucapan_count: "{total} ucapan",
    rsvp_ucapan: "Isi RSVP & Ucapan",
    ucapan_placeholder: "Tulis ucapan & doamu",
    nama_placeholder_ucapan: "Nama Anda",
    sedang_dipilih: "Sedang dipilih",
    lokasi_acara: "Lokasi Acara",
    map_lokasi_acara: "Map Lokasi Acara",
    pilih_kado_fisik: "Pilih Kado Fisik",
    pilih_kado_fisik_title: "Pilih Kado Fisik",
    gift_physical_hint: "Klik tombol dibawah untuk titip kado fisik ke acara:",
    kirim: "Kirim",
    tutorial: "Tutorial",
    info_withdraw: "Pemilik acara akan mendapatkan notifikasi realtime untuk withdraw",
    info_payment_success: "Pembayaran Berhasil",
    info_payment_success_desc: "Selamat! Pembayaran Anda sudah berhasil tervalidasi",
    info_payment_failed: "Pembayaran Gagal",
    info_payment_failed_desc: "Maaf, terjadi kesalahan saat memproses pembayaran Anda",
    info_payment_failed_desc_2: "Silakan coba lagi atau hubungi pemilik acara untuk informasi lebih lanjut",
    menutup_otomatis: "Tab ini akan tertutup otomatis...",
    menutup_otomatis_dalam: "Menutup otomatis dalam",
    salin: "Salin",
    refresh: "Refresh",
    pilih_mode: "Pilih Mode",
    memuat_data: "Memuat data...",
    hapus_data: "Hapus Data?",
    menghapus: "Menghapus...",
    ya_hapus: "Ya, Hapus",
    memuat_data_tamu: "Memuat Data Tamu...",
    opsional: "Opsional",
    memproses: "Memproses...",
    sembunyikan: "Sembunyikan",
    tampilkan: "Tampilkan",
    ditampilkan: "Ditampilkan",
    disembunyikan: "Disembunyikan",
    yakin_hapus_undangan: "Apakah Anda yakin ingin menghapus undangan",
    tindakan_permanen: "Tindakan ini tidak dapat dibatalkan.",
    back: "Kembali",
    gift_registry_send_title: "Kirim Kado Ke Pemilik Acara",
    gift_registry_send_description: "Pilih kado fisik yang akan dikirimkan langsung ke pemilik acara.",
    gift_registry_select_physical_gift: "Pilih Kado Fisik",
    gift_registry_safe_trusted: "Aman & Terpercaya",
    gift_registry_delivered: "Hadiah sampai ke penerima",
    gift_registry_special_memory: "Jadi kenangan spesial",
    mengimport: "Mengimport...",
    wajib: "Wajib",
    selesai: "Selesai",
    skip: "Lewati",
    sesuaikan: "Sesuaikan",
    tidak_ada_style: "Tidak ada style tersedia",
    hadiah_tidak_tersedia: "Hadiah tidak tersedia.",
    copy: "Copy",
    nama: "Nama",
    jumlah: "Jumlah",
    konfirmasi_via_whatsapp: "Konfirmasi via WhatsApp",
    pagination: {
      page: "Halaman",
      of: "dari",
      total: "Total",
      data: "Data",
      prev: "Prev",
      next: "Next"
    },
    update_rsvp: " Anda sudah melakukan submit RSVP, untuk merubah data RSVP silahkan, klik disini.",
    berhasil_diaktifkan: "berhasil diaktifkan",
    berhasil_dinonaktifkan: "berhasil dinonaktfikan",
    edit_undangan: "Edit Undangan",
    belum_ada_data: "Belum ada data",
    simpan_sebagai_duplikat: "Simpan sebagai duplikat",
    set_default: "Simpan sebagai default",
  },

  ThemePicker: {
    title: "Pilih Tema Undangan",
    current_theme: "Sedang Menggunakan Tema:",
    update_latest: "Update Tema Ke Versi Terbaru",
    reset_title: "Reset tema undangan?",
    reset_description: "Tema yang sedang anda gunakan akan diupdate ke versi terbaru. Ini mungkin akan menyebabkan penyesuaian tampilan pada undangan anda.",
    reset_action: "Reset Tema",
    resetting_action: "Mereset..."
  },

  DigitalEnvelope: {
    placeholder_amount: "Masukkan nominal",
    full_name: "Nama Lengkap",
    email: "Email",
    whatsapp: "Whatsapp",
    greeting: "Ucapan",
    helper_private_notification: "Tidak dilihat di publik, untuk menerima notifikasi pembayaran",
    company_name: "PT Monly Aplikasi Finansial",
    company_address: "Jl. Gunung Batur, No.88x, Buleleng, Bali",
    company_email: "info@elynk.co",
    company_phone: "+6287888030598",
    cta_continue_payment: "Lanjut Pembayaran",
    success_payment_created: "Pembayaran berhasil dibuat",
    error_save_failed: "Gagal menyimpan perubahan. Silakan coba lagi.",
    info_paragraph_start: "Amplop Digital memungkinkan tamu mengirimkan Amplop secara cashless. Pembayaran akan otomatis terverifikasi dan pemilik acara akan mendapatkan",
    info_paragraph_highlight: "notifikasi",
    info_paragraph_end: "secara realtime via whatsapp maupun email",
    how_it_works: "Bagaimana Cara Kerjanya?",
    step1_title: "Tamu Mengirim Amplop Digital",
    step1_desc: "Tamu dapat mengirimkan hadiah uang melalui undangan digital menggunakan metode pembayaran yang tersedia.",
    step2_title: "Notifikasi Realtime",
    step2_desc: "Setiap amplop yang masuk akan langsung memberi notifikasi kepada pemilik acara.",
    step3_title: "Dana Tercatat & Bisa Ditarik",
    step3_desc: "Dana yang diterima tercatat secara otomatis dan dapat ditarik (withdraw) kapan saja.",
    main_benefits: "Keuntungan Utama",
    card1_title: "Notifikasi Realtime",
    card1_desc: "Pemilik acara langsung mengetahui setiap amplop yang masuk tanpa perlu mengecek manual.",
    card2_title: "Riwayat Transaksi yang Jelas",
    card2_desc_1: "Semua transaksi tercatat rapi, lengkap dengan:",
    card2_li_1: "Nama pengirim",
    card2_li_2: "Waktu transaksi",
    card2_li_3: "Nominal yang diterima",
    card2_desc_2: "Memudahkan pemilik acara melakukan pencatatan dan rekap.",
    card3_title: "Penarikan Dana yang Mudah (Withdraw)",
    card3_desc: "Dana yang terkumpul dapat ditarik dengan proses yang mudah dan transparan sesuai ketentuan.",
    card4_title: "Aman & Transparan",
    card4_desc: "Kami menerapkan sistem yang dirancang untuk menjaga keamanan dan transparansi transaksi:",
    card4_li_1: "Setiap transaksi tercatat dalam sistem",
    card4_li_2: "Data dapat diakses kapan saja oleh pemilik acara",
    card4_li_3: "Proses withdraw dilakukan secara terkontrol",
    card5_title: "Cocok Digunakan Untuk",
    card5_li_1: "Pernikahan & acara keluarga",
    card5_li_2: "Acara adat",
    card5_li_3: "Event profesional",
    card5_li_4: "Acara dengan tamu dari berbagai lokasi",
    card6_title: "Terintegrasi dengan Sistem Undangan",
    card6_desc: "Amplop Digital Otomatis terhubung langsung dengan:",
    card6_li_1: "Custom RSVP",
    card6_li_2: "Sebar otomatis via WhatsApp",
    card6_li_3: "Laporan transaksi & notifikasi",
    card6_footer: "Semua dalam satu dashboard yang mudah digunakan."
  },
  Guest: {
    batal_pilih_semua: "Batal pilih semua",
    urutkan_berdasarkan: "URUTKAN BERDASARKAN",
    nama_a_z: "Nama A–Z",
    nama_z_a: "Nama Z–A",
    terakhir_ditambahkan: "Terakhir Ditambahkan",
    kirim_undangan: "Kirim Undangan",
    detail: "Detail",
    belum_ada_tamu: "Tamu tidak ditemukan",
    sebar_via_wa: "Sebar Via WA",
    sebar_via_email: "Sebar Via Email",
    tamu: "Tamu",
    sebar_otomatis: "Sebar Otomatis",
    mengimport_data: "Mengimport data...",
    import_file: "Import File",
    klik_untuk_mengisi: "Klik untuk mengisi",
    klik_untuk_mengedit_wa: "Klik untuk mengedit Whatsapp",
    semua_acara: "Semua Acara",
    pilih_semua: "Pilih Semua",
    menyiapkan_export: "Menyiapkan file export CSV...",
    nama: "Nama",
    disini: "disini",
    whatsapp: "Whatsapp",
    email: "Email",
    acara: "Acara",
    label: "Label",
    tanpa_label: "Tanpa Label",
    max_group: "Max Group",
    action: "Action",
    tambah_tamu_undangan: "Tambah Tamu Undangan",
    kelola_tamu: "Kelola Tamu Undangan",
    daftar_tamu: "Daftar Tamu Undangan",
    deskripsi_daftar_tamu: "Tambahkan daftar tamu yang akan anda kirimkan link undangan",
    tambah_tamu: "Tambah Tamu",
    sebar_undangan: "Sebar Undangan",
    semua_label: "Semua Label",
    cari_nama_wa: "Cari nama atau WA...",
    export_csv: "Export Data (CSV)",
    hint_mobile: "Klik baris untuk melihat detail, atau klik nama tamu untuk sebar undangan",
    nama_tamu: "Nama Tamu",
    pilih_label_opsional: "Pilih Label (Opsional)",
    max_group_desc: "Max Group - Jumlah Tamu Lain Yang Bisa Diajak Oleh Tamu",
    edit_tamu: "Edit Tamu Undangan",
    tambah_satuan: "satuan",
    tambah_cepat: "cepat",
    import_excel: "Import Excel",
    contoh_nama: "Contoh: Budi Santoso",
    err_nama_kosong: "Tulis nama tamunya dulu ya, jangan dikosongin.",
    contoh_email: "nama@email.com (Opsional)",
    err_email_typo: "Penulisan emailnya sepertinya ada yang typo.",
    err_wa_9_digit: "Nomor WA minimal harus 9 digit biar undangan bisa dikirim.",
    acara_default: "Acara (Default: Semua Acara)",
    kelola_label: "Kelola Label",
    nama_tamu_enter: "Nama Tamu (Pisahkan Enter)",
    ketik_nama: "Ketik nama...",
    download_format: "Download format disini",
    click_to_upload: "Click to upload",
    hapus_tamu: "Hapus Tamu",
    dipilih: "Dipilih"
  },
  GuestBook: {
    mode_matikan: "Matikan",
    mode_manual: "QRCode Manual (QRCode di Undangan)",
    mode_manual_desc: "Tamu menunjukkan QRCode kepada panitia acara untuk check-in.",
    mode_scan: "Scan QRCode (Seperti Peduli Lindungi)",
    mode_scan_desc: "Tamu scan QR code venue untuk check-in sendiri.",
    qr_code_manual: "QR CODE MANUAL",
    cara_menggunakan: "Cara menggunakan:",
    step_manual_1: 'Klik tombol "Aplikasi Scan Barcode Panitia" dibawah ini untuk membuka aplikasi scan oleh panitia penyambut tamu.',
    step_manual_2: "Setelah di buka, Izinkan akses kamera browser untuk Aplikasi Scan Barcode Panitia.",
    step_manual_3: "Jika ada tamu datang, minta tamu klik icon QRCode di menu undangannya, maka akan muncul QRCode.",
    step_manual_4: "Scan QRCode tersebut dengan Aplikasi Scan Barcode Panitia.",
    tonton_tutorial: "Tonton Tutorial",
    qr_code_peduli_lindungi: "QR CODE PEDULI LINDUNGI",
    desc_peduli_lindungi: "QRCode Peduli Lindungi memiliki konsep yang sama dengan aplikasi Peduli Lindungi, cara menggunakannya:",
    step_scan_1: "Panitia perlu Print QR-Code Dibawah ini lalu ditempatkan di meja penyambutan tamu.",
    step_scan_2: "Jika ada tamu yang datang, Maka minta tamu untuk klik icon QRCode di link undangan, lalu izinkan akses kamera.",
    step_scan_3: "Kemudian arahkan kamera ke QRCode dibawah ini.",
    info_umum_1: "Fitur ini digunakan untuk menggantikan Buku Tamu Manual. Tamu yang hadir akan diminta melakukan scan QRCode melalui link undangan digitalnya.",
    info_umum_2: "Tamu yang berhasil scan akan secara otomatis terdata sebagai tamu yang telah hadir di acara.",
    deskripsi_halaman: "Halaman ini mengatur penggunaan QRCode check-in buku tamu",
    pilih_mode_qrcode: "Pilih Mode QRCode Check-in",
    buka_aplikasi_scan_1: "Klik Tombol Dibawah Ini Untuk Membuka Aplikasi Scan Barcode Panitia.",
    buka_aplikasi_scan_2: "Kemudian Berikan Akses Kamera Ke Browser",
    aplikasi_scan_panitia: "Aplikasi Scan QRCode Panitia",
    layar_sapa: "Layar Sapa",
    scan_checkin_title: "SCAN CHECK-IN BUKU TAMU",
    scan_instruction_print_1: "Buka link undangan, lalu klik icon QRCode, berikan akses ke kamera,",
    scan_instruction_print_2: "kemudian arahkan kamera ke QRCode",
    memuat_qr: "Memuat QR...",
    desc_print_1: "Print QRCode ini lalu letakkan di pintu masuk acara.",
    desc_print_2: "Tamu undangan membuka link undangannya, lalu klik icon QRCode, lalu berikan akses ke kamera.",
    desc_print_3: "Arahkan kamera ke QRCode untuk melakukan Check-in.",
    menyiapkan_gambar: "Menyiapkan Gambar...",
    download_qr: "Download QRCode Check-in"
  },
  CustomRSVP: {
    section1_title: "Status kehadiran yang jelas",
    section1_desc: "Setiap tamu akan tercatat dengan status kehadiran yang jelas, sehingga kamu bisa:",
    section1_li_1: "Mengetahui jumlah tamu yang akan hadir",
    section1_li_2: "Memantau respon tamu secara realtime",
    section1_li_3: "Mengurangi kebingungan jelang hari acara",
    section2_title: "Batas jumlah tamu per undangan",
    section2_desc: "Dengan fitur ini, kamu dapat <b>menentukan berapa maksimal orang yang boleh dibawa oleh setiap tamu.</b><br/><span class='mt-2 block font-medium'>Contohnya:</span>",
    section2_li_1: "Undangan pribadi: maksimal 1-2 orang",
    section2_li_2: "Undangan keluarga: maksimal sesuai kuota",
    section2_li_3: "Undangan khusus: tanpa tambahan tamu",
    section2_footer: "Fitur ini sangat membantu untuk menjaga kapasitas acara tetap terkendali.",
    section3_title: "Kenapa fleksibel custom RSVP penting?",
    section3_desc_1: "Tanpa sistem RSVP yang terkontrol, sering terjadi:",
    section3_li_1: "Jumlah tamu melebihi kapasitas",
    section3_li_2: "Tamu datang membawa orang tambahan tanpa konfirmasi",
    section3_li_3: "Data kehadiran sulit diprediksi",
    section3_desc_2: "Dengan fleksibel Custom RSVP, kamu bisa:",
    section3_li_4: "Menjaga kapasitas acara sesuai rencana",
    section3_li_5: "Menghindari kehadiran berlebih",
    section3_li_6: "Mengelola tamu dengan lebih rapi dan profesional",
    section4_title: "Cocok digunakan untuk",
    section4_li_1: "Intimate wedding dengan jumlah tamu terbatas",
    section4_li_2: "Acara keluarga yang membutuhkan pembagian sesi",
    section4_li_3: "Event profesional yang memerlukan kontrol akses",
    section4_li_4: "Acara dengan kapasitas venue tertentu",
    section5_title: "Terintegrasi dengan fitur lainnya",
    section5_desc: "Fleksibel custom RSVP terhubung langsung dengan:",
    section5_li_1: "Reminder acara otomatis",
    section5_li_2: "QR code check-in buku tamu",
    section5_li_3: "Laporan data kehadiran tamu",
    section5_footer: "Semua data RSVP digunakan untuk membantu acara berjalan lebih tertib."
  },
  Sidebar: {
    dashboard: "Undangan Digital",
    daftar_tema: "Daftar Tema",
    inspirasi: "Inspirasi",
    tutorial: "Tutorial",
    vendor: "Vendor",
    afiliator: "Afiliator",
    menu: "Menu",
    peluang: "Peluang",
    profil: "Profil",
    preferensi: "Preferensi",
  },

  WhatsAppShare: {
    frameTitle: "Sebar via WhatsApp",
    previewView: "Preview View:",
    tabs: {
      list: "List",
      wizard: "Wizard (Buat Draft)",
      detail: "Detail Terkirim"
    },
    sandbox: {
      title: "Billing Top-up Limit",
      desc: "Integrasi gateway top-up saldo kuota WhatsApp API agency DEBS sedang disiapkan.",
      closeBtn: "Tutup Sandbox"
    },
    list: {
      title: "Sebar Via WhatsApp",
      subtitle: "Kelola pengiriman undangan via WhatsApp. Pilih template siap-pakai, cek limit, lalu kirim.",
      remainingLimit: "Sisa limit",
      unitMessage: "pesan",
      btnTopup: "Tambah Limit",
      btnCreate: "+ Buat Draft Kirim WhatsApp",
      tableTitle: "Draft & Riwayat Pengiriman",
      tableSubtitle: "Draft bisa diedit sampai Anda menekan kirim. Setelah terkirim, draft tidak bisa diubah.",
      pageSizePlaceholder: "10",
      searchPlaceholder: "Cari draft...",
      noResults: "Draft yang Anda cari tidak ditemukan.",
      emptyState: "Belum ada draft broadcast yang dibuat.",
      bulkSelect: "Dipilih",
      btnCancel: "Batal",
      btnDeleteBulk: "Hapus Draft",
      alertDelete: "Menghapus {count} item antrean draft.",
      columns: {
        name: "Nama Draft",
        recipients: "Penerima",
        template: "Template",
        status: "Status",
        updated: "Terakhir Diubah",
        actions: "Aksi"
      },
      statusType: {
        draft: "Draft",
        sent: "Terkirim",
        failed: "Sebagian Gagal"
      },
      actionsBtn: {
        continue: "Lanjutkan",
        viewDetail: "Lihat Detail"
      }
    },
    wizard: {
      defaultTitle: "Draft Kiriman Baru",
      subtitle: "Buat draft baru untuk sebar undangan via WhatsApp",
      btnSaveDraft: "Simpan sebagai Draft",
      btnNext: "Lanjut",
      steps: {
        step1: "Pilih Kontak",
        step2: "Pilih Template",
        step3: "Follow Up",
        step4: "Cek Limit",
        step5: "Finalisasi & Kirim"
      }
    },
    recipient: {
      title: "Pilih Penerima",
      subtitle: "Tentukan siapa saja tamu yang akan menerima pesan WhatsApp undangan ini.",
      all: {
        title: "Semua Kontak",
        desc: "Kirim ke seluruh kontak yang memiliki nomor WhatsApp.",
        badge: "8 kontak"
      },
      manual: {
        title: "Pilih Kontak",
        desc: "Pilih tamu satu per satu dari daftar kontak Anda.",
        selectedText: "{count} dari {total} kontak dipilih",
        searchPlaceholder: "Cari nama..."
      },
      label: {
        title: "Per Label",
        desc: "Kirim ke satu atau beberapa label sekaligus.",
        selectedText: "{total} kontak dari {count} label akan dikirim",
        filterLabel: "Filter Label",
        allActive: "Semua Label Aktif",
        unitLabel: "label",
        unitContact: "kontak"
      },
      summary: {
        title: "{count} kontak akan menerima WhatsApp",
        desc: "Semua kontak yang memiliki nomor WhatsApp valid akan dikirimi undangan ini."
      }
    },
    template: {
      title: "Pilih Template Gaya Bahasa",
      subtitle: "Pilih gaya tulisan pesan broadcast otomatis yang paling cocok.",
      previewTitle: "Preview",
      noteLimit: "Note: 1 Penerima pesan memerlukan 1 Limit",
      officialAccount: "Official Account",
      today: "HARI INI",
      noCover: "Tidak ada sampul"
    },
    limit: {
      title: "Cek Limit Pengiriman",
      subtitle: "1 kontak terkirim = 1 limit terpakai. Limit yang Anda miliki bisa dipakai kapan saja, tanpa masa berlaku.",
      cards: {
        ownedTitle: "Limit yang Dimiliki",
        ownedUnit: "pesan tersedia",
        needTitle: "Kebutuhan Kirim",
        needUnitMsg: "pesan dibutuhkan",
        afterTitle: "Sisa Setelah Kirim",
        afterUnit: "pesan tersisa",
        afterShortage: "kuota kurang",
      },
      comparison: "Kebutuhan vs Limit Anda",
      comparisonUnit: "dari {total} pesan",
      status: {
        successTitle: "Limit mencukupi",
        successDesc: "Anda punya {owned} limit dan butuh {need} untuk kiriman ini. Sisa setelah kirim: {rem} pesan.",
        errorTitle: "Limit tidak cukup",
        errorDesc: "Kebutuhan Anda ({need}) melebihi batas kuota limit yang dimiliki saat ini. Kurang {short} pesan lagi."
      },
      btnTopup: "Tambah Limit",
      footerNote: "Limit yang dibeli bisa dipakai kapan saja, tanpa masa berlaku."
    },
    send: {
      title: "Review Sebelum Kirim",
      params: {
        recipients: "Penerima",
        template: "Template",
        channel: "Channel",
        remaining: "Sisa Limit Setelah Kirim",
        unitContact: "kontak",
        unitMessage: "pesan"
      },
      listTitle: "Daftar Penerima ({count})",
      moreBadge: "+{count} lagi →",
      statusTitle: "Siap dikirim ke {count} kontak",
      statusDesc: "Pesan WhatsApp akan dikirim satu per satu untuk menghindari spam. Prosesnya butuh sekitar 2–3 menit.",
      warningText: "Setelah dikirim, draft tidak bisa diedit atau dikirim ulang. Pastikan pesan sudah benar.",
      btnSendMass: "Kirim Sekarang",
      btnTestSend: "Test Kirim WhatsApp",
      alertTest: "Pesan uji coba berhasil dikirim ke nomor WhatsApp Anda!"
    },
    followup: {
      autoTitle: "Follow Up Otomatis",
      autoDesc: "Kirim ulang pesan otomatis ke tamu setelah undangan disebar — untuk konfirmasi RSVP dan mengingatkan tamu yang akan hadir. Atur jadwal & template tiap jenis di bawah.",
      rsvpTitle: "Follow Up RSVP",
      rsvpDesc: "Dikirim ke tamu yang belum mengisi RSVP, agar mereka mengonfirmasi kehadiran.",
      reminderTitle: "Follow Up Reminder",
      reminderDesc: "Dikirim ke tamu yang sudah RSVP & menyatakan hadir, sebagai pengingat menjelang acara.",
      previewTitle: "Preview Pesan",
      scheduleLabel: "Jadwal Kirim",
      daysBefore: "H-",
      daysUnit: "hari",
      sentBefore: "Dikirim {days} hari sebelum acara ({date})",
      templateLabel: "Pilih Template",
      templates: {
        hangat: "Hangat",
        hangatDesc: "Ramah & personal",
        singkat: "Singkat",
        singkatDesc: "To the point",
        santai: "Santai",
        santaiDesc: "Akrab & ringan",
        detail: "Detail Acara",
        detailDesc: "Lengkap dengan info"
      },
      target: {
        rsvp: "Tamu yang belum mengisi RSVP",
        reminder: "Tamu yang sudah RSVP & menyatakan hadir"
      },
      modalTitle: "Pengaturan Follow Up",
      status: {
        active: "Aktif",
        inactive: "Nonaktif"
      }
    },
    detail: {
      subtitle: "Dikirim {date} · Template {tpl} · {count} kontak",
      btnExport: "Export CSV",
      cards: {
        total: "Total Dikirim",
        success: "Terkirim",
        failed: "Gagal",
        pending: "Pending",
        read: "Dibaca"
      },
      tableTitle: "Status per Kontak",
      tableSubtitle: "Riwayat pengiriman detail ke masing-masing tamu",
      filters: {
        all: "Semua",
        success: "Terkirim",
        failed: "Gagal",
        pending: "Pending",
        read: "Dibaca"
      },
      columns: {
        contact: "KONTAK",
        phone: "NOMOR WHATSAPP",
        label: "LABEL",
        status: "STATUS",
        time: "WAKTU"
      },
      emptyState: "Belum ada riwayat kontak yang tersedia.",
      noResults: "Kontak yang Anda cari tidak ditemukan."
    }
  },

  ShareViaEmail: {
    list: {
      title: "Sebar Via Email",
      subtitle: "Kelola pengiriman undangan via email. Buat draft, sesuaikan pesan, lalu kirim ke tamu Anda.",
      btnCreate: "Buat Draft Kirim Email",
      tableTitle: "Draft & Riwayat Pengiriman",
      tableSubtitle: "Draft bisa diedit sampai Anda menekan kirim. Setelah terkirim, draft tidak bisa diubah.",
      searchPlaceholder: "Cari draft…",
      emptyState: "Belum ada draft.",
      unitContact: "kontak",
      tabs: {
        all: "Semua",
        draft: "Draft",
        sent: "Terkirim"
      },
      columns: {
        name: "Nama Draft",
        recipients: "Penerima",
        template: "Template",
        status: "Status",
        updated: "Terakhir Diubah",
        actions: "Aksi"
      },
      actionsBtn: {
        continue: "Lanjutkan",
        viewDetail: "Lihat Detail"
      }
    },
    status: {
      draft: "Draft",
      sending: "Mengirim",
      pending: "Menunggu",
      sent: "Terkirim",
      partial: "Sebagian Gagal",
      failed: "Gagal"
    },
    wizard: {
      defaultTitle: "Draft Undangan Baru",
      subtitle: "Buat draft baru untuk sebar undangan via email",
      btnSaveDraft: "Simpan sebagai Draft",
      btnSaving: "Menyimpan...",
      btnNext: "Lanjut",
      stepLabel: "Step {n}",
      steps: {
        step1: "Pilih Kontak",
        step2: "Sesuaikan Template",
        step3: "Follow Up",
        step4: "Finalisasi & Kirim"
      },
      toastDraftSaved: "Draft tersimpan"
    },
    recipient: {
      title: "Pilih Penerima",
      subtitle: "Tentukan siapa saja tamu yang akan menerima email undangan ini.",
      contactField: "alamat email",
      all: {
        title: "Semua Kontak",
        desc: "Kirim ke seluruh kontak yang memiliki {field}.",
        unitContact: "kontak"
      },
      manual: {
        title: "Pilih Kontak",
        desc: "Pilih tamu satu per satu dari daftar kontak Anda.",
        selectedCount: "{count} dipilih",
        selectedText: "{count} dari {total} kontak dipilih",
        searchPlaceholder: "Cari nama atau email…",
        selectAllVisible: "Pilih semua yang terlihat",
        noMatch: "Tidak ada kontak yang cocok.",
        loadingMore: "Memuat kontak…"
      },
      label: {
        title: "Per Label",
        desc: "Kirim ke satu atau beberapa label sekaligus.",
        selectedText: "{count} label · {total} kontak",
        summaryText: "{total} kontak dari {count} label akan dikirimi",
        filterLabel: "Filter Label"
      },
      summary: {
        title: "{count} kontak akan menerima email",
        desc: "Semua kontak yang memiliki {field} valid akan dikirimi undangan ini."
      },
      validationNoContact: "Pilih minimal 1 kontak penerima terlebih dahulu.",
      validationNoLabel: "Pilih minimal 1 label penerima terlebih dahulu."
    },
    template: {
      title: "Template Pesan",
      subtitle: "Pilih tone yang sesuai dengan tamu Anda",
      composeTitle: "Susun Pesan",
      labelSender: "Nama Pengirim",
      labelSubject: "Subject",
      labelSalam: "Salam Pembuka",
      labelTitle: "Judul Pesan",
      labelSubtitle: "Sub Judul Pesan",
      labelDescription: "Deskripsi Pesan",
      labelBody: "Body Pesan",
      labelCta: "Teks Tombol (CTA)",
      btnInsertName: "+ Nama Tamu",
      btnInsertLink: "+ Link Undangan",
      previewTitle: "Preview Email",
      previewSubtitle: "Contoh untuk:",
      previewDummyName: "Made Wirawan",
      previewFrom: "From",
      previewTo: "To",
      previewErrorPrefix: "Gagal memuat preview template:",
      previewLoading: "Memuat preview…"
    },
    finalize: {
      reviewTitle: "Review Sebelum Kirim",
      reviewRecipients: "Penerima",
      reviewTemplate: "Template",
      reviewFrom: "Dari",
      reviewSubject: "Subject",
      unitContact: "kontak",
      recipientListTitle: "Daftar Penerima ({count})",
      statusTitle: "Siap dikirim ke {count} kontak",
      statusDesc: "Email akan dikirim satu per satu dengan personalisasi. Prosesnya butuh sekitar {duration}.",
      statusDuration: "2–3 menit",
      warningText: "Setelah dikirim, draft tidak bisa diedit atau dikirim ulang. Pastikan pesan sudah benar.",
      btnSendNow: "Kirim Sekarang",
      btnSending: "Mengirim...",
      btnTestSend: "Test Kirim Email",
      needRecipientTooltip: "Pilih minimal 1 kontak penerima terlebih dahulu",
      toastSending: "Undangan sedang dikirim"
    },
    detail: {
      export: "Export CSV",
      loading: "Memuat…",
      statsTotalSent: "Total Dikirim",
      statsDelivered: "Terkirim",
      statsFailed: "Gagal",
      updatedPrefix: "Diperbarui",
      templatePrefix: "Template",
      unitContact: "kontak",
      tableTitle: "Status per Kontak",
      tableSubtitle: "Riwayat pengiriman detail ke masing-masing tamu",
      filters: {
        all: "Semua",
        sent: "Terkirim",
        failed: "Gagal"
      },
      columns: {
        contact: "Kontak",
        email: "Email",
        status: "Status",
        time: "Waktu"
      },
      emptyState: "Belum ada riwayat pengiriman.",
      loadingHistory: "Memuat riwayat…",
      historyStatus: {
        success: "Terkirim",
        sent: "Terkirim",
        sending: "Mengirim",
        failed: "Gagal",
        pending: "Menunggu"
      },
      timeEmpty: "—"
    },
    test: {
      title: "Test Kirim Email",
      description: "Kirim contoh email ke alamat pribadi Anda untuk memastikan tampilan & isinya sudah sesuai.",
      successTitle: "Test berhasil dikirim",
      successDesc: "Cek inbox Anda di {email}.",
      btnDone: "Selesai",
      labelEmail: "Email Anda",
      placeholderEmail: "nama@email.com",
      hint: "Kami akan mengirim satu email contoh ke alamat ini.",
      btnCancel: "Batal",
      btnSend: "Kirim Test Email",
      btnSending: "Mengirim...",
      invalidEmail: "Format alamat email tidak valid."
    },
    guests: {
      title: "Daftar Penerima",
      description: "{count} tamu akan dikirimi undangan via email.",
      searchPlaceholder: "Cari nama atau email…",
      readyBadge: "Siap kirim",
      noMatch: "Tidak ada tamu yang cocok.",
      showingCount: "Menampilkan {count} tamu",
      btnClose: "Tutup"
    },
    toast: {
      createDraftError: "Gagal membuat draft kiriman email. Silakan coba lagi.",
      saveDraftError: "Gagal menyimpan draft. Silakan coba lagi.",
      sendEmailError: "Gagal mengirim email. Silakan coba lagi.",
      testEmailSuccess: "Email percobaan berhasil dikirim.",
      testEmailError: "Gagal mengirim email percobaan. Silakan coba lagi."
    },
    followUp: {
      title: "Follow Up Otomatis",
      description: "Kirim ulang pesan otomatis ke tamu setelah undangan disebar — untuk konfirmasi RSVP dan mengingatkan tamu yang akan hadir. Atur jadwal & template tiap jenis di bawah.",
      status_active: "Aktif",
      status_inactive: "Nonaktif",
      save_button: "Simpan Pengaturan",
      preview_title: "Preview Pesan",
      preview_meta: "dikirim H-{days} · contoh untuk",
      preview_subject_label: "Subjek",
      schedule_label: "Jadwal Kirim",
      days_prefix: "H-",
      days_unit: "hari",
      days_before_event: "sebelum acara {date}",
      subject_label: "Subjek Email",
      body_label: "Isi Pesan",
      rsvp: {
        label: "Follow Up RSVP",
        desc_prefix: "Dikirim ke tamu yang",
        desc_bold: "belum mengisi RSVP",
        desc_suffix: ", agar mereka mengonfirmasi kehadiran.",
        default_subject: "Sudah konfirmasi kehadiran, {{namaTamu}}?",
        default_body: "Halo {{namaTamu}},\n\nKami belum menerima konfirmasi kehadiran Anda untuk pernikahan Komang & Ayu. Kehadiran Anda sangat berarti bagi kami.\n\nMohon luangkan waktu sebentar untuk mengisi konfirmasi melalui undangan digital berikut."
      },
      reminder: {
        label: "Follow Up Reminder",
        desc_prefix: "Dikirim ke tamu yang",
        desc_bold: "sudah RSVP & menyatakan hadir",
        desc_suffix: ", sebagai pengingat menjelang acara.",
        default_subject: "Sampai jumpa sebentar lagi, {{namaTamu}}!",
        default_body: "Halo {{namaTamu}},\n\nTerima kasih sudah menyatakan hadir di pernikahan kami. Ini pengingat kecil menjelang hari-H.\n\nSimpan detail acara & lokasi pada undangan digital berikut. Sampai jumpa!"
      },
      insert_vars: {
        namaTamu: "namaTamu",
        linkUndangan: "linkUndangan",
        namaAcara: "namaAcara"
      }
    },
  },

  Avatar_Dropdown: {
    profile: "Profil",
    ganti_password: "Ganti Password",
    logout: "Keluar",
    pengaturan: "Pengaturan"
  },
  CustomForm: {
    title: "Custom Form",
    premium: "Premium",
    no_primary_fields: "Tidak ada field primary yang tersedia",
    note_hadir: "Pertanyaan dibawah akan muncul ketika tamu memilih Hadir",
    new_fields: "Field Baru (Belum Disimpan)",
    unsaved: "Belum Disimpan",
    edit_primary: "Edit Primary Field",
    edit_settings_for: "Ubah pengaturan untuk field",
    question_label: "Label Pertanyaan",
    placeholder_question_label: "Masukkan label pertanyaan",
    text_option_attend: "Teks Opsi Hadir",
    example_attend: "Contoh: Ya, Saya Hadir",
    text_option_not_attend: "Teks Opsi Tidak Hadir",
    example_not_attend: "Contoh: Maaf, Tidak Bisa Hadir",
    hide_doubt_option: "Sembunyikan Opsi Ragu",
    hide_doubt_desc: "Nonaktifkan pilihan ragu-ragu untuk tamu.",
    text_option_doubt: "Teks Opsi Ragu-ragu",
    example_doubt: "Contoh: Masih Ragu",
    add_question: "Tambah Pertanyaan",
    edit_question: "Edit Pertanyaan",
    add_question_desc: "Atur jenis dan opsi pertanyaan khusus untuk tamu Anda.",
    question_type: "Tipe Pertanyaan",
    select_type: "Pilih Tipe",
    short_text: "Teks Pendek (Isian)",
    multiple_choice: "Pilihan Ganda (Dropdown)",
    example_question: "Contoh: Dari pihak mana Anda hadir?",
    options_choices: "Opsi Pilihan",
    separate_comma: "Pisahkan dengan koma (Pria, Wanita)",
    example_writing: "Contoh penulisan: Pihak Pria, Pihak Wanita",
    is_required: "Wajib Diisi?",
    required_desc: "Tamu wajib mengisi field ini untuk submit.",
    save_question: "Simpan Pertanyaan",
    new_fields_short: "Field Baru",
    masukkan: "Masukkan",
    pilih: "Pilih",
    kehadiran: "kehadiran",
    hadir: "Hadir",
    tidak_hadir: "Tidak Hadir",
    masih_ragu: "Masih Ragu"
  },
  Dashboard: {
    data_acara: "Data Acara",
    tambah_acara: "Tambah Acara",
    aktifkan_undangan: "Aktifkan Undangan",
    edit_undangan: "Edit Undangan",
    preview_hasil: "Preview Hasil",
    pilih_tema: "Pilih Tema",
    sebar_undangan: "Sebar Undangan",
    status_undangan: "Status Undangan",
    hapus_undangan: "Hapus Undangan",
    belum_ada_data: "Belum Ada Data Acara",
    belum_ada_data_desc: "Klik Tambah Acara → Pilih Jenis Acara → Isi Seluruh Data → Klik Simpan → Klik Preview",
    id: "ID",
    total_acara: "Total Acara",
    acara_aktif: "Acara Aktif",
    acara_nonaktif: "Acara Tidak Aktif",
    duplikat_undangan: "Duplikat Undangan",
    anda_akan_menduplikat: "Anda akan menduplikat undangan",
    catatan_duplikat: "Catatan: Hasil duplikat akan otomatis diatur ke paket",
    free: "Free",
    ya_duplikat: "Ya, Duplikat",
    acara_saya: "Acara Saya",
    dibagikan_ke_saya: "Dibagikan ke Saya",
    belum_ada_kolaborasi: "Belum Ada Kolaborasi",
    belum_ada_kolaborasi_desc: "Saat ini belum ada undangan dari orang lain yang dibagikan ke akun Anda.",
    semua_acara_ditampilkan: "Semua acara telah ditampilkan",
    akses_kolaborasi: "Akses Kolaborasi",
    tanpa_judul: "Tanpa Judul",
    arsip: "Arsip",
    arsip_kosong: "Belum Ada Acara Diarsipkan",
    arsip_kosong_desc: "Undangan yang Anda arsipkan akan muncul di sini dan dapat dipulihkan kapan saja.",
    jenis_acara: "Jenis Acara",
    paket: "Paket",
    urutkan: "Urutkan:"
  },
  Status: {
    belum_aktif: "Belum Aktif",
    paket_pro: "Paket PRO",
    paket_basic: "Paket Basic",
    expired: "Kedaluwarsa",
    aktif: "Aktif",
    nonaktif: "Tidak Aktif",
    pending: "Menunggu",
    draft: "Draft"
  },
  Add_Event: {
    pilih_jenis_acara: "Pilih Jenis Acara",
    cari_jenis_acara: "Cari jenis acara...",
    tidak_ada_hasil_pencarian: "Tidak ada jenis acara yang ditemukan untuk",
    kembali: "Kembali",
    lanjutkan: "Lanjutkan"
  },
  Event_Type: {
    custom: "Acara Custom",
    pernikahan: "Pernikahan",
    mepandes: "Mepandes",
    khitanan: "Khitanan",
    birthday: "Ulang Tahun",
    kelulusan: "Acara Wisuda/UP/Ujian",
    natal: "Natal",
    ucapan: "Ucapan Online",
    halal: "Halal Bihalal",
    aqiqah: "Aqiqah",
    "3bulanan": "3 Bulanan",
    melaspas: "Melaspas",
    tahlilan: "Tahlilan",
    baptisan: "Baptisan",
    komuni: "Komuni Suci Pertama",
    pentahbisan: "Pentahbisan",
    description: {
      custom: "Buat undangan custom sesuai kebutuhan Anda",
      pernikahan: "Buat undangan pernikahan untuk disebar ke seluruh tamu undangan",
      mepandes: "Acara mepandes atau potong gigi untuk Umat Hindu",
      khitanan: "Acara khitanan atau sunatan untuk umat muslim",
      birthday: "Undangan acara ulang tahun",
      kelulusan: "Acara wisuda, ujian, atau kelulusan",
      natal: "Undangan perayaan hari natal",
      ucapan: "Ucapan online untuk berbagai keperluan",
      halal: "Acara halal bihalal atau silaturahmi",
      aqiqah: "Cocok untuk semua acara anak dalam Islam",
      "3bulanan": "Acara 3 bulanan atau tingkeban untuk ibu hamil",
      melaspas: "Acara melaspas untuk umat Hindu",
      tahlilan: "Acara tahlilan atau doa bersama",
      baptisan: "Ritual untuk menyucikan diri dan mengakui keimanan Kepada Yesus",
      komuni: "Komuni suci pertama untuk umat Katolik",
      pentahbisan: "Acara pentahbisan atau pelantikan"
    }
  },
  Form_Event: {
    title: "Buat Acara Baru",
    subtitle: "Lengkapi informasi acara Anda di bawah ini",
    add_event_title: "Tambah Event",
    edit_event_title: "Edit Event",
    event_address: "Alamat Acara",
    placeholder_event_address: "Alamat lengkap acara",
    event_date: "Tanggal Acara",
    select_event_date: "Pilih tanggal acara",
    custom_date: "Custom Tanggal",
    placeholder_custom_date: "Tulis format tanggal bebas, misal: 15-16",
    custom_day: "Custom Hari",
    placeholder_custom_day: "Contoh: Sabtu",
    start_time: "Jam Mulai Acara",
    placeholder_start_time: "Pilih jam mulai",
    end_time: "Jam Selesai Acara",
    placeholder_end_time: "Pilih jam selesai",
    timezone: "Zona Waktu",
    placeholder_timezone: "Contoh: WITA",
    custom_time: "Custom Jam",
    placeholder_custom_time: "Masukkan jam acara custom, misal: 09.00 - selesai",
    until_finished: "Sampai Selesai",
    google_maps_link: "Link Google Maps",
    placeholder_google_maps: "https://goo.gl/maps/...",
    update_event: "Update Event",
    save_event: "Simpan Event",
    add_event: "Tambah Event",
    save_order: "Simpan Urutan",
    placeholder_event_name: "Contoh: Akad Nikah",
    jenis_acara: "Jenis Acara",
    pilih_jenis_acara: "Pilih jenis acara",
    tentang_jenis_acara: "Tentang jenis acara ini:",
    no_whatsapp: "No WA Penerima (No WA Pemilik Acara)",
    placeholder_whatsapp: "087888999xxx atau 6287888999xxx",
    info_whatsapp: "*Nomor ini tidak akan ditampilkan di undangan",
    tanggal_acara: "Tanggal Acara",
    informasi_penting: "Informasi Penting:",
    info_1: "Semua data bisa diubah lagi nanti setelah acara dibuat",
    info_2: "Undangan akan aktif setelah melakukan pembayaran",
    info_3: "Dengan membuat acara, Anda menyetujui",
    syarat_ketentuan: "Syarat & Ketentuan",
    kami: "kami",
    buat_acara: "Buat Acara",
    membuat_acara: "Membuat Acara...",
    required: "wajib diisi",
    fields: {
      nama_acara: "Nama Acara",
      nama_anak: "Nama Anak",
      nama_ayah: "Nama Ayah",
      nama_ibu: "Nama Ibu",
      nama_pria: "Nama Mempelai Pria",
      nama_wanita: "Nama Mempelai Wanita",
      agama: "Agama",
      nama_yang_ultah: "Nama yang Berulang Tahun",
      ulang_tahun_ke: "Ulang Tahun Ke",
      placeholders: {
        nama_acara: "Masukkan nama acara",
        nama_anak: "Masukkan nama anak",
        nama_ayah: "Masukkan nama ayah",
        nama_ibu: "Masukkan nama ibu",
        nama_pria: "Masukkan nama mempelai pria",
        nama_wanita: "Masukkan nama mempelai wanita",
        pilih_agama: "Pilih agama",
        nama_yang_ultah: "Masukkan nama yang berulang tahun",
        ulang_tahun_ke: "Masukkan angka ulang tahun"
      }
    },
    agama_options: {
      islam: "Islam",
      kristen: "Kristen",
      katolik: "Katolik",
      hindu: "Hindu",
      buddha: "Buddha",
      khonghucu: "Khonghucu"
    }
  },
  ManageMenu: {
    titles: {
      progress_setup: "Progres Pengaturan Undangan",
      setting_undangan_dasar: "Setting Undangan Dasar",
      progress_setup_undangan: "Progress Setup Undangan",
      edit_langsung_di_undangan: "Edit Tampilan Undangan",
      kado_fisik_dan_amplop_digital: "Kado Fisik Dan Amplop Digital",
      edit_cepat_di_form: "Edit Cepat di Form",
      tema_undangan: "Tema Undangan",
      urutan_susunan_komponen: "Urutan Susunan Komponen",
      atur_form_rsvp_dan_kehadiran: "Form RSVP Kehadiran",
      musik_undangan: "Musik Undangan",
      warna_dan_font_tema: "Warna & Font Tema",
      form_kehadiran_dan_ucapan: "Form Kehadiran & Ucapan",
      fitur_auto_scroll: "Fitur Auto-Scroll",
      tampilan_whatsapp: "Tampilan WhatsApp",
      kado_fisik_dan_sticker_gift: "Kado Fisik & Sticker Gift",
      notifikasi_undangan: "Notifikasi Undangan",
      pengaturan: "Pengaturan",
      ubah_nama_tamu_dan_sebar: "Sebar Undangan",
      sebar_otomatis_satu_klik: "Sebar Undangan Otomatis atau Manual",
      qrcode_checkin_buku_tamu: "QRCode Check-in Buku Tamu",
      export_desain_cetak: "Export Menjadi Desain Cetak",
      custom_undangan_video: "Custom Undangan Video",
      undangan_cetak_fisik: "Buat Undangan Cetak Fisik (Print)",
      statistik_laporan_sebar: "Ringkasan Laporan Sebar",
      laporan_ucapan_dan_kehadiran: "Laporan Kehadiran RSVP Tamu Undangan",
      laporan_buku_tamu: "Laporan Check-in Buku Tamu",
      laporan_kado_fisik: "Laporan Kado Fisik",
      laporan_amplop_digital: "Laporan Amplop Digital",
      laporan_sticker_gift: "Laporan Sticker Gift",
      pengaturan_google_maps: "Pengaturan Google Maps",
      foto_sampul: "Foto Sampul",
      profile_user: "Profil Pengguna",
      sebar_undangan_via_email: "Sebar via Email",
      sebar_via_whatsapp: "Sebar via WhatsApp",
      sebar_via_whatsapp_desc: "Kirim undangan otomatis melalui WhatsApp",
    },
    upgrade: {
      free_title: "Buka Lebih Banyak",
      free_subtitle: "Tingkatkan level undanganmu",
      pro_title: "Upgrade Premium",
      pro_subtitle: "Buka fitur eksklusif VIP",
      premium_title: "Member Premium",
      premium_subtitle: "Semua fitur telah terbuka"
    },
    descriptions: {
      edit_langsung_di_undangan: "Edit informasi undangan langsung di halaman undangan.",
      edit_cepat_di_form: "Edit informasi undangan dengan cepat.",
      kado_fisik_dan_amplop_digital_desc: "Atur alamat pengiriman kado fisik dan rekening amplop digital",
      tema_undangan: "Pilih dan sesuaikan tema undangan Anda.",
      atur_form_rsvp_dan_kehadiran_desc: "Atur pertanyaan untuk formulir konfirmasi kehadiran tamu undangan.",
      urutan_susunan_komponen: "Atur konfigurasi dasar undangan Anda.",
      musik_undangan: "Kelola daftar tamu undangan.",
      warna_dan_font_tema: "Atur jadwal dan timeline acara.",
      form_kehadiran_dan_ucapan: "Tambahkan musik latar belakang.",
      fitur_auto_scroll: "Upload dan atur galeri foto.",
      tampilan_whatsapp: "Informasi hadiah dan amplop digital.",
      kado_fisik_dan_sticker_gift: "Atur lokasi dan petunjuk arah.",
      notifikasi_undangan: "Bagikan undangan ke media sosial.",
      pengaturan: "Lihat statistik undangan Anda.",
      ubah_nama_tamu_dan_sebar: "Tambah list nama tamu penerima undangan dan sebarkan",
      sebar_otomatis_satu_klik: "Sebar undangan dengan cepat hanya dalam sekali klik ke ribuan penerima",
      qrcode_checkin_buku_tamu: "Buku tamu digital dengan menggunakan QRCode",
      export_desain_cetak: "Export undangan link menjadi desain cetak seperti pamflet dan undangan cetak",
      custom_undangan_video: "Minta admin untuk membuatkan undangan video dari undangan link",
      undangan_cetak_fisik: "Sebar undangan fisik, cetak melalui indoinvite",
      statistik_laporan_sebar: "Lihat laporan lengkap siapa yang membuka undangan, memberi ucapan dll",
      laporan_ucapan_dan_kehadiran: "Lihat siapa yang memberi ucapan dan konfirmasi kehadiran",
      laporan_buku_tamu: "Lihat siapa yang sudah hadir dan mengisi buku tamu digital",
      laporan_kado_fisik: "Lihat siapa yang mengirimkan kado fisik ke acara",
      laporan_amplop_digital:
        "Halaman ini menampilkan total amplop digital dan list tamu undangan yang memberikan amplop digital",
      laporan_sticker_gift: "Lihat siapa yang mengirimkan sticker gift di undangan",
      pengaturan_google_maps: "Atur lokasi acara kamu",
      sebar_undangan_via_email: "Kelola pengiriman undangan via email. Buat draft, sesuaikan pesan, lalu kirim ke tamu Anda."
    },
    groups: {
      customize: "Sesuaikan Undangan",
      share: "Sebar Undangan",
      report: "Laporan Undangan"
    },
    lockedBanner: {
      "title": "Undangan Terkunci",
      "desc": "Masa trial berakhir. Tamu tidak bisa membuka undangan & semua fitur nonaktif."
    },
    showMore: "Tampilkan lebih banyak",
    showLess: "Tampilkan lebih sedikit",
    share_invitation: "Sebar Undangan"
  },
  TrialWidget: {
    mobile: {
      lockedTitle: "Undangan Terkunci",
      lockedSubtitle: "Trial berakhir · aktifkan kembali",
      activeTitle: "Masa Trial Aktif",
      upgradeButton: "Upgrade",
    },
    desktop: {
      expiredTitle: "Trial Berakhir",
      expiredSubtitle: "Undangan terkunci",
      expiredDesc: "Tamu tidak dapat membuka undangan & semua fitur nonaktif. Upgrade untuk mengaktifkan kembali.",
      upgradeNowButton: "Upgrade Sekarang",
      activeTitle: "Masa Trial Aktif",
      activeSubtitle: "dari 3 hari gratis",
      selectPackageButton: "Pilih Paket Upgrade",
    },
    units: {
      days: "HARI",
      hours: "JAM",
      minutes: "MNT",
      seconds: "DTK",
    },
  },
  LockedModal: {
    title: "Undangan Terkunci",
    description: "Masa trial 3 hari telah berakhir. Tamu tidak dapat membuka undangan dan semua fitur pengelolaan dinonaktifkan. Upgrade paket untuk mengaktifkannya kembali.",
    upgradeButton: "Upgrade untuk Membuka",
  },
  Modal: {
    form_acara: "Form Acara",
    mau_pilih_mana: "Mau Pilih Mana?",
    anda_memilih: "Anda memilih:",
    edit_slug_title: "Edit Link Undangan",
    edit_slug_label: "Link Undangan Baru",
    edit_slug_placeholder: "the-wedding-of...",
    edit_slug_error_empty: "Slug (link) tidak boleh kosong.",
    edit_slug_error_save: "Gagal menyimpan link undangan.",
    edit_slug_button_cancel: "Batal",
    edit_slug_button_saving: "Menyimpan...",
    edit_slug_button_save: "Simpan Perubahan"
  },
  ProgressSetup: {
    title: "Progress Setup Undangan",
    steps_left: "langkah lagi untuk",
    perfect_invitation: "undangan yang sempurna",
    desc: "Lengkapi langkah di bawah ini supaya undanganmu makin siap dibagikan ke para tamu.",
    completed: "selesai",
    step_of_1: "dari",
    step_of_2: "langkah selesai",
    checklist_title: "Checklist Setup",
    badge_required: "Wajib",
    badge_optional: "Opsional",
    btn_skip: "Skip",
    btn_customize: "Sesuaikan",
    status_completed: "Selesai",
    items: {
      add_guest: { title: "Tambah tamu undangan", desc: "Masukkan minimal satu tamu untuk mulai menyebar link undangan." },
      add_address: { title: "Tambah alamat penerima kado", desc: "Tampilkan alamat agar tamu mudah mengirim kado fisik ke kamu." },
      add_wa: { title: "Tambah WA notifikasi kado & amplop digital", desc: "Terima notifikasi WhatsApp tiap ada kado atau amplop digital masuk." },
      add_event: { title: "Tambah acara", desc: "Buat minimal satu acara agar tamu tahu kapan & di mana undanganmu berlangsung." },
      custom_rsvp: { title: "Custom form RSVP", desc: "Atur pertanyaan konfirmasi kehadiran sesuai kebutuhan acaramu." },
      add_photo: { title: "Tambah foto prewedding", desc: "Unggah galeri foto prewedding untuk mempercantik halaman undangan." }
    },
    setup: {
      "progress_setup_title": "Progres Pengaturan Undangan",
      "count_label": "{done} dari {total} langkah selesai",
      title: "Daftar Periksa Pengaturan",
      "step_status_info": "Status setiap langkah terdeteksi otomatis dari datamu — tak perlu menandai manual.",
      "label": {
        "custom_slug": "Custom Slug URL",
        "add_wa_notif": "Tambahkan WA Notifikasi Penerima kado & amplop digital",
        "add_alamat_gift": "Tambah Alamat Penerima Kado",
        "add_tamu": "Tambah Tamu",
        "add_acara": "Tambah Acara",
        "add_faq": "Tambah FAQ",
        "qrcode_checkin": "Aktifkan Digital Guest Book (QRCode Check-in)",
        "add_media": "Tambah Media di Undangan",
        "custom_gift_registry": "Custom gift registry (Pilih kado yang ditampilkan di Undangan)",
        "custom_form_rsvp": "Custom Form RSVP",
        "add_love_story": "Tambah Love Story"
      },
      "description": {
        "custom_slug": "Atur URL undangan sesuai keinginan",
        "add_wa_notif": "Aktifkan notifikasi WhatsApp untuk penerima kado dan amplop digital",
        "add_alamat_gift": "Tambahkan alamat untuk pengiriman kado",
        "add_tamu": "Tambahkan daftar tamu undangan",
        "add_acara": "Tambahkan detail acara pernikahan",
        "add_faq": "Tambahkan pertanyaan yang sering ditanyakan (FAQ) di undangan",
        "qrcode_checkin": "Aktifkan fitur buku tamu digital dengan QR Code check-in",
        "add_media": "Tambahkan foto atau video di undangan",
        "custom_gift_registry": "Pilih hadiah yang ingin ditampilkan di registry",
        "custom_form_rsvp": "Sesuaikan form RSVP sesuai kebutuhan",
        "add_love_story": "Ceritakan kisah cinta Anda di undangan"
      }
    },
    "headline": {
      "loading": "Memuat progress setup...",
      "complete": "Semua langkah selesai — undangan siap disebar!",
      "short": "{done} dari {total} langkah selesai",
      "energetic": "Tinggal {remaining} langkah lagi — kamu hampir sampai!",
      "default": "{remaining} langkah lagi untuk undangan yang sempurna"
    },
    "subhead": {
      "loading": "Sebentar, kami sedang menyiapkan daftar langkahmu.",
      "complete": "Kerja bagus! Kamu sudah bisa mulai membagikan undangan ke seluruh tamu.",
      "short": "Selesaikan sisa langkah berikut untuk merampungkan undanganmu.",
      "energetic": "Sedikit lagi undanganmu siap. Yuk rampungkan langkah di bawah ini.",
      "default": "Lengkapi langkah di bawah ini supaya undanganmu makin siap dibagikan ke para tamu."
    },
    "errors": {
      "load_failed": "Gagal memuat progress setup undangan.",
      "retry": "Coba lagi"
    }
  },
  Search: {
    placeholder: "Cari...",
    tidak_ditemukan: "Tidak ditemukan",
    hasil_untuk: "Hasil pencarian untuk",
    menampilkan: "Menampilkan",
    dari: "dari",
    total: "total",
    placeholder_acara: "Cari nama acara...",
    acara_tidak_ditemukan: "Acara tidak ditemukan",
    tidak_ada_acara_cocok: "Tidak ada acara yang cocok dengan kata kunci",
    kolaborasi_tidak_ditemukan: "Kolaborasi tidak ditemukan",
    tidak_ada_kolaborasi_cocok: "Tidak ada undangan kolaborasi yang cocok dengan kata kunci",
  },
  Pagination: {
    sebelumnya: "Sebelumnya",
    selanjutnya: "Selanjutnya",
    kembali: "Kembali",
    lanjutkan: "Lanjutkan",
    halaman: "Halaman",
    dari_total: "dari",
    ke: "ke",
    menampilkan: "Menampilkan"
  },
  Breadcrumb: {
    beranda: "Beranda",
    dashboard: "Dashboard",
    acara: "Acara",
    buat_acara: "Buat Acara",
    edit_acara: "Edit Acara"
  },
  Error: {
    gagal_import: "Gagal mengimport data",
    email_wajib_diisi: "Email wajib diisi.",
    judul_acara_wajib_diisi: "Judul acara wajib diisi.",
    whatsapp_wajib_diisi: "Nomor WhatsApp wajib diisi.",
    format_email_tidak_valid: "Format email tidak valid.",
    format_whatsapp_tidak_valid: "Nomor WhatsApp harus berupa angka (10-15 digit).",
    terjadi_kesalahan: "Terjadi kesalahan",
    coba_lagi: "Coba lagi",
    halaman_tidak_ditemukan: "Halaman tidak ditemukan",
    kembali_ke_beranda: "Kembali ke beranda",
    koneksi_terputus: "Koneksi terputus",
    periksa_koneksi: "Periksa koneksi internet Anda",
    error_404: "404 - Halaman Tidak Ditemukan",
    error_500: "500 - Terjadi Kesalahan Server",
    error_generic: "Terjadi kesalahan. Silakan coba lagi nanti.",
    "belum_publish": "Belum Dipublish",
    "error_publish_undangan_desc": "Link Undangan Tidak Dapat Dibuka",
    "error_publish_undangan_lead": "Maaf! Link undangan yang Anda buka tidak terpublish. Hubungi pemilik acara untuk informasi lebih lanjut.",
    "error_publish_undangan_desc_2": "Hubungi pemilik undangan untuk memastikan undangan sudah dipublish sebelum membukanya.",
    "error_private_undangan_badge": "Undangan Private",
    "error_private_undangan": "Maaf! Link undangan yang Anda buka adalah Link Private",
    "error_private_undangan_desc": "Hanya tamu undangan yang sudah terdaftar yang bisa membuka undangan. Hubungi pemilik acara untuk informasi lebih lanjut.",
    "error_private_undangan_hint": "Hubungi pemilik undangan untuk mendapatkan akses, atau pastikan nama Anda sudah terdaftar sebagai tamu. Silakan coba lagi.",
    fitur_maintenance: "Fitur ini sedang dalam perbaikan (Maintenance).",
    hanya_pemilik: "Hanya Pemilik (Owner) acara yang dapat mengakses fitur ini.",
    pilih_user_dulu: "Silakan pilih user dari daftar pencarian terlebih dahulu.",
    akun_sendiri: "Anda tidak dapat menambahkan akun Anda sendiri.",
    maksimal_hak_akses: "Maaf, maksimal hak akses hanya untuk 10 pengguna.",
    sudah_ada_akses: "Pengguna ini sudah memiliki hak akses.",
    gagal_tambah_akses: "Duh, gagal menambahkan hak akses. Coba beberapa saat lagi ya.",
    gagal_hapus_akses: "Waduh, gagal menghapus hak akses. Coba lagi yuk!",
    gagal_hapus_field: "Gagal menghapus field",
    label_wajib: "Label field harus diisi",
    gagal_primary: "Gagal update primary field",
    field_name_wajib: "Field name harus diisi",
    opsi_wajib: "Minimal 1 opsi harus diisi",
    gagal_simpan_field: "Gagal menyimpan field",
    gagal_ubah_visibility: "Gagal mengubah visibility field",
    tidak_ada_field_baru: "Tidak ada field baru untuk disimpan",
    gagal_simpan_custom_form: "Gagal menyimpan custom form",
    gagal_simpan_pilihan: "Gagal menyimpan pilihan.",
    nama_penerima_wajib: "Nama Lengkap Penerima wajib diisi!",
    nomor_hp_wajib: "Nomor HP wajib diisi!",
    nomor_hp_kurang_valid: "Nomor HP kurang valid. Pastikan nomor sudah benar!",
    provinsi_wajib: "Provinsi wajib dipilih!",
    kabupaten_wajib: "Kabupaten wajib dipilih!",
    kecamatan_wajib: "Kecamatan wajib dipilih!",
    desa_wajib: "Desa/Kelurahan wajib dipilih!",
    kodepos_wajib: "Kode POS wajib diisi!",
    alamat_lengkap_wajib: "Alamat Lengkap wajib diisi!",
    gagal_simpan_pengaturan: "Gagal menyimpan pengaturan.",
    gagal_memuat_tamu: "Gagal memuat daftar tamu.",
    nama_tamu_wajib: "Oops, nama tamunya belum diisi nih.",
    email_tidak_valid: "Hmm, sepertinya format emailnya kurang pas. Cek lagi ya!",
    wa_kependekan: "Ups, nomor WA-nya kependekan. Pastikan valid ya!",
    gagal_update_data: "Gagal memperbarui data. Lihat Console Log (Inspect Element).",
    nama_tamu_wajib_singkat: "Nama tamu tidak boleh kosong!",
    gagal_simpan_perubahan: "Gagal menyimpan perubahan",
    gagal_proses_data: "Gagal memproses data",
    gagal_export: "Gagal mengekspor data tamu.",
    wa_minimal_9: "Format Gagal: Whatsapp minimal 9 digit!",
    email_tidak_valid_singkat: "Format Gagal: Email tidak valid!",
    max_group_negatif: "Gagal: Max group tidak boleh negatif!",
    isi_minimal_satu: "Isi minimal satu nama",
    pilih_file: "Pilih file",
    pilih_1_data: "Silakan pilih 1 data saja untuk diedit.",
    tamu_tidak_ditemukan: "Tamu tidak ditemukan!",
    pilih_template_dulu: "Silakan pilih template dulu.",
    gagal_simpan_template: "Gagal menyimpan template.",
    gagal_simpan_template_custom: "Gagal menyimpan template custom.",
    gagal_mulai_sebar: "Gagal memulai proses sebar. Silakan coba lagi.",
    selesaikan_penerima_dulu: "Selesaikan langkah Penerima dulu.",
    selesaikan_sebelumnya_dulu: "Selesaikan langkah sebelumnya dulu.",
    data_undangan_belum_siap: "Data undangan belum siap. Silakan refresh halaman.",
    data_id_belum_dimuat: "Data ID belum dimuat. Mohon tunggu sebentar atau refresh halaman.",
    kesalahan_data_id: "Terjadi kesalahan data ID. Silakan coba lagi.",
    data_encrypted_belum_siap: "Data Encrypted ID belum siap. Tunggu sebentar atau refresh halaman.",
    gagal_hapus_data: "Gagal menghapus data.",
    gagal_perbarui_rsvp: "Gagal memperbarui RSVP.",
    balasan_wajib: "Balasan tidak boleh kosong",
    gagal_kirim_balasan: "Gagal mengirim balasan.",
    tamu_manual_no_detail: "Data tamu manual tidak memiliki detail tambahan.",
    gagal_muat_data_refresh: "Gagal memuat data terbaru. Silakan coba refresh.",
    gagal_penarikan: "Gagal memproses penarikan",
    undangan_tidak_ditemukan: "Undangan tidak ditemukan.",
    gagal_hapus_undangan: "Gagal menghapus undangan",
    tidak_bisa_hapus_undangan_aktif: "Undangan yang sudah aktif atau sudah membeli paket tidak dapat dihapus.",
    gagal_mengarsipkan: "Gagal mengarsipkan undangan",
    gagal_memulihkan: "Gagal memulihkan undangan",
    data_acara_tidak_ditemukan: "Data acara tidak ditemukan. Silakan mulai ulang.",
    gagal_memuat_tema: "Gagal memuat daftar tema.",
    payload_tidak_valid: "Data data tidak valid.",
    gagal_memuat_paket: "Gagal memuat daftar paket.",
    pilih_paket_dulu: "Silakan pilih paket terlebih dahulu.",
    gagal_buat_undangan: "Gagal membuat undangan. Silakan coba lagi.",
    gagal_logout: "Gagal terhubung ke server saat logout. Silakan coba lagi.",
  },
  Success: {
    import_berhasil: "Import data tamu berhasil!",
    berhasil_disimpan: "Data berhasil disimpan",
    berhasil_dihapus: "Data berhasil dihapus",
    berhasil_diupdate: "Data berhasil diperbarui",
    acara_berhasil_dibuat: "Acara berhasil dibuat",
    undangan_berhasil_dikirim: "Undangan berhasil dikirim",
    berhasil_diduplikat: "Hore! Undangan berhasil diduplikat.",
    berhasil_diarsipkan: "Undangan berhasil diarsipkan",
    berhasil_dipulihkan: "Undangan berhasil dipulihkan",
    id_disalin: "ID disalin",
    berhasil_tambah_akses: "Hore! Berhasil menambahkan hak akses pengguna.",
    berhasil_hapus_akses: "Sip! Hak akses pengguna berhasil dicabut.",
    field_dihapus: "Field berhasil dihapus:",
    primary_diupdate: "Primary field berhasil diupdate",
    field_diupdate: "Field berhasil diupdate",
    field_diubah_belum_simpan: "Field berhasil diubah (belum disimpan)",
    field_ditambah_belum_simpan: "Field berhasil ditambahkan (belum disimpan)",
    field_diaktifkan: "berhasil diaktifkan",
    field_dinonaktifkan: "berhasil dinonaktifkan",
    custom_form_disimpan: "Custom form berhasil disimpan",
    kado_diperbarui: "Daftar kado berhasil diperbarui!",
    pengaturan_disimpan: "Pengaturan berhasil disimpan!",
    data_diperbarui: "Data berhasil diperbarui!",
    tamu_diperbarui: "Data tamu berhasil diperbarui!",
    data_dihapus: "Data berhasil dihapus",
    berhasil_export: "Berhasil mengunduh data tamu CSV!",
    tamu_ditambahkan: "Tamu ditambahkan",
    pesan_link_disalin: "Pesan & Link disalin!",
    pesan_disalin: "Pesan disalin",
    template_dipilih: "Template '{name}' dipilih.",
    template_custom_disimpan: "Template custom tersimpan.",
    link_disalin: "Link berhasil disalin!",
    pembayaran_berhasil: "Pembayaran berhasil!",
    limit_diperbarui: "Limit Anda telah diperbarui.",
    proses_sebar_dimulai: "Proses sebar otomatis dimulai!",
    undangan_dikirim: "undangan sedang dikirim.",
    template_disimpan: "Template {name} disimpan.",
    rsvp_diperbarui: "Data RSVP berhasil diperbarui!",
    balasan_terkirim: "Balasan berhasil dikirim!",
    kehadiran_diupdate: "Kehadiran berhasil diupdate!",
    penarikan_berhasil: "Permintaan penarikan dana berhasil dikirim",
    teks_sebar_disalin: "Teks sebar berhasil disalin!",
    dipilih: "dipilih.",
    template_custom_tersimpan: "Template custom tersimpan.",
    undangan_dihapus: "Undangan berhasil dihapus",
    undangan_berhasil_dibuat: "Undangan berhasil dibuat!",
    berhasil_logout: "Berhasil logout!",
  },
  Confirmation: {
    yakin_hapus: "Yakin ingin menghapus?",
    tindakan_tidak_bisa_dibatalkan: "Tindakan ini tidak bisa dibatalkan",
    ya_hapus: "Ya, Hapus",
    yakin_keluar: "Yakin ingin keluar?",
    data_belum_disimpan: "Data yang belum disimpan akan hilang",
    ya_keluar: "Ya, Keluar",
    tetap_disini: "Tetap di sini",
    yakin_hapus_field: "Apakah Anda yakin ingin menghapus field",
    ya_hapus_data: "Ya, Hapus Data",
    hapus_banyak_data: "Apakah Anda yakin ingin menghapus {count} data yang dipilih? Tindakan ini tidak dapat dibatalkan."
  },
  Pricing: {
    paket_saat_ini: "Paket Saat Ini",
    upgrade_sekarang: "Upgrade Sekarang",
    paket_harga_elynk: "Paket Harga Elynk",
    data_belum_tersedia: "Data paket belum tersedia.",
    sudah_termasuk: "Termasuk dalam Paket"
  },
  Share: {
    detail_tamu: "Detail Tamu",
    title: "Kirim & Bagikan Undangan",
    description: "Sebarkan undangan kepada para tamu undangan, baik secara manual satu-per-satu atau sebar otomatis dalam sekali klik",
    sebar_otomatis: "Sebar Otomatis",
    sebar_manual: "Sebar Manual",
    pernikahan_kami: "Pernikahan Kami",
    custom: "Custom",
    sebar_link: "Sebar Link",
    tamu_undangan_contoh: "Tamu+Undangan",
    ubah_nama_tamu_hint: "Untuk merubah nama tamu di undangan, ubah link setelah",
    sebar_dengan_template: "Sebar Dengan Template",
    pilih_template: "Pilih Template",
    sedang_menggunakan_template: "Sedang menggunakan template",
    cari_tamu: "Cari tamu...",
    link: "Link",
    sebar: "Sebar",
    sebar_lain: "Sebar Lain",
    belum_dipilih: "Belum dipilih",
    status_dibaca: "Dibaca",
    status_terkirim: "Terkirim",
    status_mengirim: "Mengirim",
    status_gagal: "Gagal",
    status_menunggu: "Menunggu",
    waktu_diterima: "Waktu Diterima",
    batch_id: "Batch ID",
    langkah_sebar: "Langkah - langkah sebar !",
    sisa_limit: "Sisa Limit:",
    penerima_undangan: "Penerima Undangan",
    total_penerima_terpilih: "Total {count} Penerima Terpilih",
    pilih_siapa_menerima: "Pilih siapa yang akan menerima undangan",
    template_pesan: "Template Pesan",
    menggunakan: "Menggunakan:",
    pilih_pesan_dikirim: "Pilih pesan yang akan dikirim",
    limit: "Limit",
    kurang_limit: "Kurang {count} Limit! Klik untuk tambah.",
    limit_tersedia: "Limit Tersedia: {limit} (Butuh: {need})",
    konfirmasi_kirim: "Konfirmasi & Kirim",
    siap_disebarkan: "Siap untuk disebarkan",
    mulai_sebar: "Mulai Sebar Undangan",
    note_limit: "Note: 1 Penerima pesan memerlukan 1 Limit",
    bot_name: "Elynk",
    official_account: "Official Account",
    hari_ini: "Hari Ini",
    cover_undangan: "Cover Undangan.jpg",
    belum_ada_template: "Belum ada template dipilih.",
    silakan_pilih_template: "Silakan pilih template di menu kiri.",
    history_sebar: "History Sebar",
    semua_status: "Semua Status",
    belum_ada_riwayat: "Belum ada riwayat pengiriman.",
    kelola_penerima: "Kelola Penerima Undangan",
    semua_tamu_undangan: "Semua Tamu Undangan",
    desc_semua_tamu: "Semua tamu undangan yang memiliki nomor WA di Kelola Tamu",
    pilih_dari_label: "Pilih Dari Label",
    terpilih_teks: "terpilih",
    terpilih_btn: "Terpilih",
    desc_pilih_label: "Pilih penerima undangan dari label tertentu",
    tidak_ada_label: "Tidak ada label tersedia.",
    pilih_dari_tamu: "Pilih Dari Tamu Undangan",
    desc_pilih_manual: "Pilih dari daftar tamu undangan secara manual",
    tidak_ada_tamu: "Tidak ada tamu ditemukan",
    simpan_penerima_undangan: "Simpan Penerima Undangan",
    simpan_penerima: "Simpan Penerima",
    cari_nama_wa: "Cara nama tamu atau WA...",
    pilih_template_sebar_otomatis: "Pilih Template Sebar Otomatis",
    pilih_template_sebar_manual: "Pilih Template Sebar Manual",
    tulis_pesan_undangan: "Tulis pesan undangan...",
    sisipkan: "Sisipkan:",
    nama_tamu_btn: "Nama Tamu",
    link_undangan_btn: "Link Undangan",
    pilih_template_placeholder: "Pilih template...",
    simpan_template: "Simpan Template",
    edit_template_ini: "Edit Template Ini",
    gunakan_template_ini: "Gunakan Template Ini",
    tambah_limit_sebar: "Tambah Limit Sebar",
    desc_limit_sebar: "Limit digunakan untuk mengirim pesan secara otomatis ke tamu undangan.",
    pembelian_limit: "Pembelian Limit",
    total_pembayaran: "Total Pembayaran",
    lanjut_pembayaran: "Lanjut Pembayaran",
    konfirmasi_sebar: "Konfirmasi Sebar",
    mulai_sebar_undangan: "Mulai Sebar Undangan?",
    anda_akan_mengirim_ke: "Anda akan mengirimkan undangan kepada",
    penerima: "penerima",
    terpilih_pastikan_limit: "terpilih. Pastikan kuota limit Anda mencukupi.",
    memproses: "Memproses...",
    kirim_sekarang: "Kirim Sekarang",
    sebar_ulang: "Sebar Ulang",
    kirim_undangan: "Kirim Undangan",
    default_umum: "Default Umum",
    muslim_1: "Muslim 1",
    english_1: "English 1",
    undangan_title: "Undangan",
    link_sebar: "Link Sebar",
    tersalin: "Tersalin",
    copy: "Copy",
    sesuaikan_template: "Sesuaikan Template",
    teks_tersalin: "Teks Tersalin!",
    copy_teks_sebar: "Copy Teks Sebar",
    membuka_whatsapp: "Membuka WhatsApp...",
    kirim_ke_whatsapp: "Kirim ke Whatsapp",
    membuka_share: "Membuka Share...",
    sebar_lainnya: "Sebar Lainnya",
    sebar_masal_otomatis: "Sebar Masal Otomatis",
    sebar_undangan_manual: "Sebar Undangan Manual",
    lainnya: "Lainnya",
    nama_acara_btn: "Nama Acara",
    nomor_pengirim: "Nomor WA Panitia",
  },

  Time: {
    hari_ini: "Hari ini",
    kemarin: "Kemarin",
    minggu_lalu: "Minggu lalu",
    bulan_lalu: "Bulan lalu",
    tahun_lalu: "Tahun lalu",
    detik_lalu: "detik yang lalu",
    menit_lalu: "menit yang lalu",
    jam_lalu: "jam yang lalu",
    hari_lalu: "hari yang lalu"
  },
  Component: {
    "c-gift-registry": "Hadiah Kado Fisik",
    "c-open-invitation-button": "Tombol Buka Undangan",
    "c-guest-name": "Nama Tamu",
    "c-ucapan-footer": "Teks (Footer)",
    "c-image-list": "List Gambar",
    "c-sampul": "Gambar Sampul",
    "c-profile": "List Profil",
    "c-link": "List Link",
    "c-doa": "Teks (Doa)",
    "c-embed-map": "Map Embed",
    "c-ucapan-penutup": "Teks (Ucapan Penutup)",
    "c-acara": "Detail Acara",
    "c-data-wanita": "Profil Pengantin Wanita",
    "c-data-pria": "Profil Pengantin Pria",
    "c-ucapan-pembuka": "Teks (Ucapan Pembuka)",
    "c-galery": "Galeri Foto",
    "c-kehadiran": "Konfirmasi Kehadiran (RSVP)",
    "c-pengumuman": "Teks (Pengumuman)",
    "c-hadiah": "Hadiah Amplop Digital",
    "c-hitung-mundur": "Countdown Acara",
    "c-susunan-acara": "Susunan Acara",
    "c-story": "Cerita Cinta",
    "c-nama-acara": "Judul (Heading)",
    "c-dresscode": "Dresscode",
    "c-faq": "FAQ",
    "c-video": "Video",
    "c-list-ucapan": "List Ucapan",
    "c-spacer": "Spacer"
  },
  EditComponent: {
    edit_gallery: "Galeri Foto",
    edit_sampul: "Gambar Sampul",
    edit_groom: "Profil Pengantin Pria",
    edit_dresscode: "Dresscode",
    edit_faq: "FAQ",
    edit_video: "Video",
    edit_list_ucapan: "List Ucapan",
    edit_bride: "Profil Pengantin Wanita",
    edit_image_list: "List Gambar",
    edit_susunan_acara: "Susunan Acara",
    edit_profile: "List Profil",
    edit_link: "List Link",
    edit_love_story: "Cerita Cinta",
    edit_gift_registry: "Hadiah Kado Fisik",
    edit_gift: "Hadiah Amplop Digital",
    edit_countdown: "Countdown Acara",
    edit_attendance: "Konfirmasi Kehadiran (RSVP)",
    reset_data_tooltip: "Reset Data",
    reset_confirm_title: "Konfirmasi Reset Data",
    reset_confirm_desc: "Apakah Anda yakin ingin mereset data {name}? Tindakan ini tidak dapat dibatalkan.",
    reset_confirm_button: "Reset Data",
    reset_loading_button: "Mereset...",
  },
  Settings: {
    deskripsi_header: "Setting undangan untuk mengatur nama acara, sampul, notifikasi dan pengaturan lainnya",
    preference_title: "Preferensi",
    preference_deskripsi_header: "Atur preferensi aplikasi seperti bahasa tampilan",
    language_setting: "Setting Bahasa",
    language_setting_desc: "Pilih bahasa tampilan aplikasi yang Anda gunakan.",
    inspirasi_menu: "Inspirasi",
    inspirasi_title: "Inspirasi",
    inspirasi_desc: "Jelajahi undangan digital buatan pengguna lain untuk inspirasimu.",
    inspirasi_muat_lebih_banyak: "Muat lebih banyak",
    inspirasi_kosong: "Belum ada inspirasi untuk kategori ini.",
    inspirasi_kategori_semua: "Semua",
    inspirasi_kategori_pernikahan: "Pernikahan",
    inspirasi_kategori_khitanan: "Khitanan",
    inspirasi_kategori_grand_opening: "Grand Opening",
    inspirasi_kategori_aqiqah: "Aqiqah",
    inspirasi_kategori_ulang_tahun: "Ulang Tahun",
    tutorial_menu: "Tutorial",
    tutorial_title: "Tutorial",
    tutorial_desc: "Panduan langkah demi langkah untuk memaksimalkan undanganmu.",
    tutorial_muat_lebih_banyak: "Muat lebih banyak",
    tutorial_kosong: "Belum ada tutorial untuk kategori ini.",
    tutorial_kategori_semua: "Semua",
    tutorial_kembali: "Kembali ke daftar tutorial",
    tutorial_tidak_ditemukan: "Tutorial tidak ditemukan.",
    tutorial_video_panduan: "Video Panduan",
    tutorial_langkah_langkah: "Langkah-langkah",
    tutorial_tips: "Tips",
    detail_acara: "Detail Acara",
    notifikasi: "Notifikasi",
    hak_akses: "Hak Akses",
    pengaturan_undangan: "Pengaturan Undangan",
    placeholder_judul_acara: "Contoh: The Wedding of Romeo & Juliet",
    deskripsi_acara: "Deskripsi Acara",
    placeholder_deskripsi_acara: "Tuliskan deskripsi singkat acara...",
    no_image: "No Image",
    pilih_foto_sampul: "Pilih Foto Sampul",
    pilih_gambar_media: "Pilih Gambar dari Media",
    deskripsi_notifikasi: "Atur notifikasi kehadiran dan pesan konfirmasi.",
    cari_negara: "Cari negara atau kode...",
    negara_tidak_ditemukan: "Negara tidak ditemukan",
    chat_id_telegram: "Chat ID Telegram",
    placeholder_chat_id: "Masukkan Chat ID",
    notif_kado: "Notifikasi Kado & Amplop Digital",
    notif_rsvp: "Notifikasi RSVP Kehadiran",
    notif_marketing: "Notifikasi Marketing Elynk.co",
    deskripsi_hak_akses: "Mengatur siapa saja yang bisa mengelola acara Anda",
    cari_pengguna: "Cari Pengguna Berdasarkan Email/Nama",
    placeholder_cari_pengguna: "Ketik email atau nama...",
    akun_anda: "Akun Anda",
    memiliki_hak_akses: "Yang memiliki hak akses",
    hapus_akses: "Hapus Akses",
    deskripsi_pengaturan: "Mengatur status undangan, tipe undangan dan bahasa.",
    status_publish: "Status Publish",
    publish_publik: "Publish (Bisa diakses publik)",
    draft_admin: "Draft (Hanya admin)",
    tipe_undangan: "Tipe Undangan",
    tamu_publik: "Tamu Publik",
    tamu_private: "Tamu Private (Hanya yang diundang)",
    bahasa_undangan: "Bahasa Undangan",
    indonesia: "Indonesia",
    english: "English",
    default_max_group: "Default Max Group",
    contoh_10: "Contoh: 10",
    deskripsi_max_group: "Batas maksimal jumlah tamu yang bisa hadir dalam satu grup undangan."
  },
  SettingsFont: {
    font_header: "Font Header",
    font_sub_header: "Font Sub Header",
    font_description: "Font Deskripsi",
    pilih_font: "Pilih Font",
    atur_style_font: "Atur Style Font",
    "reset_font_title": "Kembalikan font ke default?",
    "reset_font_description": "Font header, sub header, dan deskripsi akan dikembalikan ke pengaturan default tema. Tindakan ini tidak bisa dibatalkan."
  },
  "SettingsColor": {
    "reset_warna": "Reset warna",
    "reset_warna_title": "Kembalikan warna ke default?",
    "reset_warna_description": "Semua warna, termasuk warna utama, sekunder, teks judul, teks, dan warna lainnya, akan dikembalikan ke pengaturan default tema. Tindakan ini tidak bisa dibatalkan.",
    "mereset": "Mereset..."
  },
  Gift: {
    setting_tab: "Setting",
    pilih_kado_fisik_tab: "Pilih Kado Fisik",
    kado_fisik: "Kado Fisik",
    amplop_digital: "Amplop Digital",
    pilih_kado: "Pilih Kado",
    sesuaikan_kado: "Sesuaikan Kado",
    pilih_semua_kado: "Pilih Semua Kado",
    pilih_beberapa_kado: "Pilih Beberapa Kado",
    cari_kado_placeholder: "Cari kado...",
    tidak_ada_master_kado: "Tidak ada data master kado.",
    list_kado_tampil: "List Kado Yang Tampil Di Undangan",
    cari_kado_terpilih: "Cari kado terpilih...",
    refresh_data: "Refresh Data",
    belum_ada_kado_dipilih: "Belum ada kado yang dipilih.",
    gambar: "Gambar",
    kado: "Kado",
    harga: "Harga",
    kado_pernikahan_default: "Kado pernikahan",
    fitur_kado_fisik: "Fitur Kado Fisik",
    info_kado_fisik_1: "Titip Kado Fisik memungkinkan tamu mengirimkan kado langsung dari Undangan Digital. Setelah pembayaran terkonfirmasi, pemilik acara akan mendapatkan",
    notifikasi: "notifikasi",
    info_kado_fisik_2: ", tim kami akan menyiapkan dan mengirimkan kado sesuai konfirmasi pemilik acara.",
    aktifkan_kado_fisik: "Aktifkan Fitur Kado Fisik",
    detail_penerima_kado: "Detail Penerima Paket Kado",
    nama_lengkap: "Nama Lengkap",
    placeholder_nama_lengkap: "Nama Lengkap Penerima",
    nomor_hp: "Nomor HP",
    alamat_pengiriman: "Alamat Pengiriman",
    pilih_provinsi: "Pilih Provinsi",
    pilih_kabupaten: "Pilih Kabupaten",
    pilih_kecamatan: "Pilih Kecamatan",
    pilih_desa: "Pilih Desa/Kelurahan",
    kode_pos: "Kode POS",
    alamat_lengkap: "Alamat Lengkap",
    placeholder_alamat: "Alamat Lengkap (Jalan, No. Rumah, RT/RW, Patokan)",
    fitur_amplop_digital: "Fitur Amplop Digital",
    info_amplop_digital_1: "Amplop Digital memungkinkan tamu mengirimkan Amplop secara cashless. Pembayaran akan otomatis terverifikasi dan pemilik acara akan mendapatkan",
    info_amplop_digital_2: "secara realtime via whatsapp dan email (Pastikan Anda sudah Setting Notifikasi di menu ",
    setting_notifikasi_link: "Setting Notifikasi",
    info_amplop_digital_3: "), pemilik acara dapat melakukan withdraw di halaman report.",
    aktifkan_amplop_digital: "Aktifkan Fitur Amplop Digital",
    pesan_fitur_kado_dinonaktifkan: "Fitur Kado Fisik saat ini dinonaktifkan. Tamu tidak akan dapat melihat atau mengirim kado fisik pada halaman undangan.",
    pesan_fitur_amplop_dinonaktifkan: "Fitur Amplop Digital saat ini dinonaktifkan. Tamu tidak akan dapat melakukan pembayaran cashless pada halaman undangan."
  },
  Statistics: {
    title: "Statistik Sebar Undangan",
    loading_stats: "Sedang memuat data statistik...",
    desc: "Laporan lengkap untuk melihat data sebar undangan",
    total_digital_envelope: "Total Amplop Digital",
    detail_digital_envelope: "Detail Amplop Digital",
    total_physical_gift: "Total Kado Fisik",
    gift_unit: "Kado",
    detail_gift: "Detail Kado",
    view_invitation: "View Undangan",
    open_invitation: "Buka Undangan",
    wishes: "Ucapan",
    guest_confirmation: "Konfirmasi Tamu",
    copy_account: "Salin Rekening",
    click_maps: "Klik Maps",
    click_gallery: "Klik Galeri",
    guest_wishes: "Ucapan Tamu",
    detail_wishes: "Detail Ucapan",
    name: "Nama",
    no_name: "Tanpa Nama",
    no_wishes_data: "Belum ada data ucapan",
    detail_rsvp: "Detail RSVP",
    confirmation: "Konfirmasi",
    attend: "Hadir",
    person_unit: "Orang",
    no_confirmation_data: "Belum ada data konfirmasi"
  },
  Report: {
    pilih_acara: "Pilih Acara...",
    edit_data_rsvp: "Edit Data RSVP",
    konfirmasi_kehadiran: "Konfirmasi Kehadiran",
    pilih_kehadiran: "Pilih Kehadiran",
    jumlah_hadir: "Jumlah Hadir",
    memuat_pertanyaan_tambahan: "Memuat pertanyaan tambahan...",
    custom_form_lainnya: "Custom Form Lainnya",
    title: "Laporan Kehadiran & Ucapan",
    info_detail: "Informasi detail data ini",
    ucapan_dari: "Ucapan dari",
    detail_ucapan: "Detail Ucapan",
    sembunyikan_ucapan: "Sembunyikan Ucapan",
    tampilkan_ucapan: "Tampilkan Ucapan",
    rsvp_tab: "RSVP",
    wishes_tab: "Ucapan",
    export_csv: "Export Laporan (CSV)",
    total_konfirmasi: "Total Konfirmasi",
    status_hadir: "Akan Hadir",
    status_tidak_hadir: "Tidak Hadir",
    status_ragu: "Masih Ragu",
    semua_acara: "Semua Acara",
    semua_status: "Semua Status",
    search_guest_placeholder: "Cari nama tamu...",
    guest_name: "Nama Tamu",
    nama: "Nama",
    attendance: "Kehadiran",
    konfirmasi: "Konfirmasi",
    amount: "Jumlah",
    hadir: "Hadir",
    time: "Waktu",
    actions: "Aksi",
    total_ucapan: "Total Ucapan",
    replied: "Dibalas",
    not_replied: "Belum Dibalas",
    all_status: "Semua Status",
    search_wishes_placeholder: "Cari nama atau ucapan...",
    cari_ucapan: "Cari ucapan...",
    wish: "Ucapan",
    ucapan: "Ucapan",
    status: "Status",
    replied_by_owner: "Balasan Pemilik Acara",
    delete_confirmation_title: "Konfirmasi Hapus",
    delete_confirmation_desc: "Apakah Anda yakin ingin menghapus data ini secara permanen? Tindakan ini tidak dapat dibatalkan.",
    hapus_data_desc: "Anda akan menghapus {count} data terpilih.",
    konfirmasi_hapus_pesan_tamu: "Apakah anda yakin ingin menghapus pesan {name}?",
    konfirmasi_sembunyikan_ucapan: "Apakah anda yakin menyembunyikan ucapan ini?",
    konfirmasi_tampilkan_ucapan: "Apakah anda yakin menampilkan ucapan ini?",
    confirm_delete: "Ya, Hapus",
    menyiapkan_export: "Menyiapkan file export...",
    custom_field: "Custom Field",
    tanpa_nama: "Tanpa Nama",
    klik_detail: "Klik untuk lihat detail",
    balas: "Balas",
    desc: "Laporan untuk melihat tamu yang bersedia hadir dan tidak hadir di acara",
    tamu_konfirmasi: "Tamu Konfirmasi",
    belum_konfirmasi: "Belum Konfirmasi",
    jumlah_orang_hadir: "Jumlah Orang Yang Akan hadir",
    cari_tamu: "Cari tamu...",
    belum_ada_rsvp: "Belum ada data RSVP.",
    belum_ada_ucapan: "Belum ada data Ucapan.",
    orang: "Orang",
    balas_ucapan: "Balas Ucapan",
    balas_ucapan_desc: "Berikan apresiasi kepada tamu atas ucapan dan doa mereka.",
    pilih_ucapan: "Pilih Ucapan",
    pilih_ucapan_placeholder: "Pilih ucapan...",
    tulis_balasan: "Tulis balasan ucapan...",
    mengirim: "Mengirim...",
    update_balasan: "Update Balasan",
    kirim: "Kirim",
    detail_tamu: "Detail Tamu",
    memuat_detail_tamu: "Memuat detail tamu...",
    data_tamu_tidak_ditemukan: "Data tamu tidak ditemukan.",
    tamu_umum: "Tamu Umum",
    rsvp_checkin: "RSVP & Check-in",
    kado_amplop: "Kado & Amplop",
    nama_terdaftar: "Nama Terdaftar",
    max_kuota_hadir: "Max Kuota Hadir",
    tidak_dibatasi: "Tidak dibatasi",
    rsvp: "RSVP",
    balasan_anda: "Balasan Anda",
    data_checkin: "Data Check-in (Buku Tamu)",
    sudah_checkin: "Sudah Check-in",
    belum_checkin: "Belum Check-in",
    jumlah_hadir_aktual: "Jumlah Hadir Aktual",
    waktu_hadir: "Waktu Hadir",
    kado_fisik: "Kado Fisik",
    tidak_ada_kado_fisik: "Tidak ada data kado fisik.",
    amplop_digital: "Amplop Digital",
    total_amplop_digital: "Total Amplop Digital",
    transfer: "Transfer",
    belum_hadir: "Belum Hadir",
    tamu_telah_hadir: "Tamu Telah Hadir",
    laporan_checkin: "Laporan Check-in Buku Tamu",
    desc_checkin: "Daftar tamu yang telah mengisi buku tamu atau melakukan check-in via QR Code.",
    total_tamu_undangan: "Total Tamu Undangan (RSVP)",
    tamu_berhasil_checkin: "Tamu Berhasil Check-in",
    jumlah_orang_checkin: "Jumlah Orang Check-in",
    checkin_manual: "Check-in Manual",
    belum_ada_checkin: "Belum ada tamu yang check-in.",
    desc_checkin_manual: "Lakukan pencatatan kehadiran tamu yang hadir di lokasi acara.",
    tamu_terdaftar: "Tamu Terdaftar",
    belum_terdaftar: "Belum Terdaftar",
    pilih_tamu: "Pilih Tamu",
    ketik_nama_tamu: "Ketik nama tamu...",
    mencari_tamu: "Mencari tamu...",
    tamu_tidak_ditemukan: "Tamu tidak ditemukan.",
    masukkan_nama_tamu: "Masukkan nama tamu",
    alamat_email_tamu: "Alamat email tamu",
    simpan_checkin: "Simpan Check-in",
    total_hadir: "Total Hadir",
    edit_kehadiran: "Edit Kehadiran",
    masukkan_jumlah_kehadiran: "Masukkan jumlah kehadiran",
    gift: "Kado",
    status_pending: "Pending",
    status_received: "Diterima",
    status_sent: "Dikirim",
    status_processed: "Diproses",
    desc_kado_fisik: "Halaman ini menampilkan daftar kado yang dikirimkan tamu undangan.",
    total_kado: "Total Kado",
    total_pemberi_kado: "Total Pemberi Kado",
    cari_pengirim_kado: "Cari tamu pengirim kado...",
    belum_ada_kado_fisik: "Belum ada data kado fisik.",
    hapus_data_kado: "Hapus Data Kado",
    desc_hapus_kado: "Apakah Anda yakin ingin menghapus kado ini dari daftar? Tindakan ini tidak dapat dibatalkan.",
    tanggal: "Tanggal",
    nama_tamu: "Nama Tamu",
    hamba_allah: "Hamba Allah",
    channel: "Channel",
    nominal: "Nominal",
    biaya_pg: "Biaya Payment Gateway",
    total: "Total",
    nama_penerima: "Nama Penerima",
    wd_fee: "WD Fee",
    dana_diterima: "Dana Diterima",
    tipe_transaksi: "Tipe Transaksi",
    penarikan: "Penarikan",
    pemasukan: "Pemasukan",
    transaksi: "Transaksi",
    saldo: "Saldo",
    sisa_saldo: "Sisa Saldo",
    tarik_dana: "Tarik Dana",
    pemberi_amplop_digital: "Pemberi Amplop Digital",
    riwayat_pemasukan: "Riwayat Pemasukan",
    riwayat_penarikan: "Riwayat Penarikan",
    riwayat_saldo: "Riwayat Saldo",
    cari_transaksi: "Cari transaksi...",
    belum_ada_data_x: "Belum ada data {x}.",
    status_success: "Success",
    status_failed: "Failed",
    status_process: "Process",
    silakan_pilih_bank: "Silakan pilih bank / dompet digital",
    nomor_rekening_wajib: "Nomor rekening wajib diisi",
    nama_pemilik_wajib: "Nama pemilik rekening wajib diisi",
    minimal_penarikan: "Minimal penarikan adalah Rp 50.000",
    saldo_tidak_mencukupi: "Saldo Anda tidak mencukupi",
    penarikan_dana: "Penarikan Dana",
    bank_dompet_digital: "Bank / Dompet Digital",
    pilih_bank: "Pilih Bank",
    memuat_bank: "Memuat list bank...",
    cari_nama_bank: "Cari nama bank...",
    bank_tidak_ditemukan: "Bank tidak ditemukan.",
    nomor_rekening: "Nomor Rekening",
    placeholder_rekening: "Masukkan nomor rekening / HP",
    nama_pemilik_rekening: "Nama Pemilik Rekening",
    placeholder_nama_pemilik: "Atas nama di buku tabungan",
    nominal_penarikan: "Nominal Penarikan",
    saldo_kurang_alert: "Saldo tidak mencukupi!",
    ringkasan_penarikan: "Ringkasan Penarikan",
    biaya_layanan: "Biaya Layanan (15%)",
    total_diterima: "Total Diterima",
    data_sesuai: "Data diatas sudah sesuai"
  },

  LandingPage: {
    menu_home: "Home",
    menu_fitur: "Fitur",
    menu_harga: "Harga",
    menu_tema: "Tema",
    menu_vendor: "Vendor",
    menu_login: "Login",
    menu_register: "Register",
    fitur_layanan: "Fitur Layanan",

    fitur_1_title: "All-in-One Undangan Digital Platform",
    fitur_1_desc: "Semua fitur dasar undangan digital tersedia lengkap di Elynk.co. Gratis digunakan, bisa disebar...",
    fitur_2_title: "Sebar Otomatis via WhatsApp",
    fitur_2_desc: "Sebarkan undangan digital ke seluruh tamu secara otomatis melalui WhatsApp. Tidak perlu...",
    fitur_3_title: "QR Code Check-in Buku Tamu",
    fitur_3_desc: "Setiap tamu mendapatkan QR Code unik untuk proses check-in di lokasi acara. Saat hari acara,...",
    fitur_4_title: "Amplop Digital Otomatis",
    fitur_4_desc: "Elynk menyediakan sistem amplop digital terintegrasi yang memungkinkan tamu mengirimkan hadiah...",
    fitur_5_title: "Fleksibel Custom RSVP",
    fitur_5_desc: "Kelola konfirmasi kehadiran tamu dengan sistem RSVP yang dapat disesuaikan sepenuhnya.",
    fitur_6_title: "Reminder Acara Otomatis",
    fitur_6_desc: "Reminder Acara Otomatis di Elynk.co memastikan tamu yang sudah mengisi RSVP tidak lupa...",
    fitur_7_title: "Split Acara Setiap Tamu",
    fitur_7_desc: "Dalam satu undangan, kamu bisa membuat beberapa acara berbeda (misal akad, resepsi,...",
    fitur_8_title: "Titip Kado Otomatis",
    fitur_8_desc: "Tamu dapat memilih dan membeli kado untuk pemilik acara langsung melalui Elynk....",
    hero_title: "Undangan Digital Profesional No.1 Di Indonesia. Mulai Gratis Sekarang Untuk Semua Jenis Acara.",
    hero_desc: "Kelola undangan, RSVP, pengingat acara, hingga amplop digital dalam satu platform yang rapi, otomatis, dan hemat tanpa batas.",
    hero_img_alt: "Mockup Undangan Digital",
    tema_tanpa_nama: "Tema Tanpa Nama",
    gratis: "Gratis",
    preview_btn: "Preview",
    gunakan_tema_btn: "Gunakan Tema",
    preview_theme_title: "Pilihan Tema Elegan Untuk Berbagai Jenis Acara",
    preview_theme_desc_1: "Setiap tema dirancang dengan tampilan modern, rapi, dan responsif,",
    preview_theme_desc_2: "siap digunakan untuk acara personal hingga profesional.",
    belum_ada_tema: "Belum ada tema",
    tema_tahap_pembuatan: "Tema untuk kategori ini sedang dalam tahap pembuatan.",
    new_feature_title: "Semua Fitur Undangan Digital Dalam Satu Platform",
    new_feature_subtitle: "Gratis digunakan, bisa disebar unlimited, dan tanpa masa aktif.",
    new_feature_img_alt: "Fitur All-in-One Elynk.co",
    new_feature_heading_1: "All-in-One Undangan Digital",
    new_feature_heading_2: "Platform (GRATIS)",
    new_feature_desc_1: "Semua fitur dasar undangan digital tersedia lengkap di Elynk.co. Gratis digunakan, bisa disebar unlimited, dan ",
    new_feature_desc_bold: "tanpa masa aktif",
    new_feature_list_title: "Fitur Undangan yang Kamu Dapatkan:",
    new_feature_list_1: "Galeri Foto & Video",
    new_feature_list_2: "Lokasi & Google Maps",
    new_feature_list_3: "Musik Undangan",
    new_feature_list_4: "Pilihan & Custom Tema",
    new_feature_list_5: "Our Story / Love Story",
    new_feature_list_6: "Dan 20+ Fitur Lainnya",
    new_feature_btn: "Lihat selengkapnya",
    custom_rsvp_title: "Fleksibel Custom RSVP",
    custom_rsvp_desc_1: "Kelola konfirmasi kehadiran tamu dengan sistem RSVP yang dapat disesuaikan sepenuhnya. Kamu bisa mengatur pertanyaan RSVP sesuai kebutuhan acara, menentukan status kehadiran, serta ",
    custom_rsvp_desc_bold: "membatasi jumlah orang yang boleh dibawa oleh setiap tamu.",
    custom_rsvp_list_title: "Fitur ini membantu kamu:",
    custom_rsvp_list_1: "Menjaga kapasitas acara tetap sesuai rencana",
    custom_rsvp_list_2: "Menghindari kehadiran berlebih",
    custom_rsvp_list_3: "Mengelola tamu dengan lebih rapi dan terkontrol",
    custom_rsvp_btn: "Lihat selengkapnya",
    custom_rsvp_img_alt: "Fitur Custom RSVP Elynk",
    sebar_otomatis_title: "Sebar Otomatis via WhatsApp",
    sebar_otomatis_desc: "Sebarkan undangan digital ke seluruh tamu secara otomatis melalui WhatsApp. Tidak perlu mengirim satu per satu secara manual cukup siapkan daftar tamu, dan sistem akan membantu proses pengiriman secara terstruktur.",
    sebar_otomatis_list_title: "Hasilnya:",
    sebar_otomatis_list_1: "Proses sebar undangan lebih cepat",
    sebar_otomatis_list_2: "Minim kesalahan pengiriman",
    sebar_otomatis_list_3: "Lebih efisien untuk tamu dalam jumlah besar",
    sebar_otomatis_btn: "Lihat selengkapnya",
    sebar_otomatis_img_alt: "Sebar Otomatis via WhatsApp Elynk",
    qr_checkin_title: "QR Code Check-in Buku Tamu",
    qr_checkin_desc: "Setiap tamu mendapatkan QR Code unik untuk proses check-in di lokasi acara. Saat hari acara, tamu cukup memindai QR Code untuk melakukan registrasi kehadiran.",
    qr_checkin_list_title: "Keuntungannya:",
    qr_checkin_list_1: "Proses check-in lebih cepat dan tertib",
    qr_checkin_list_2: "Data kehadiran tercatat otomatis",
    qr_checkin_list_3: "Cocok untuk acara formal dan profesional",
    qr_checkin_btn: "Lihat selengkapnya",
    qr_checkin_img_alt: "QR Code Check-in Buku Tamu Elynk",
    guest_split_title: "Split Acara Setiap Tamu",
    guest_split_desc: "Dalam satu undangan, kamu bisa membuat beberapa acara berbeda (misal akad, resepsi, after party, atau sesi khusus lainnya).",
    guest_split_list1_title: "Setiap tamu dapat diatur:",
    guest_split_list1_1: "Hanya diundang ke acara tertentu",
    guest_split_list1_2: "Tidak bisa mengakses acara yang bukan untuknya",
    guest_split_list2_title: "Fitur ini sangat ideal untuk:",
    guest_split_list2_1: "Acara dengan segmentasi tamu",
    guest_split_list2_2: "Intimate wedding",
    guest_split_list2_3: "Event yang membutuhkan kontrol akses",
    guest_split_btn: "Lihat selengkapnya",
    guest_split_img_alt: "Split Acara Setiap Tamu Elynk",
    digital_envelope_title: "Amplop Digital Otomatis",
    digital_envelope_desc_1: "Elynk menyediakan sistem amplop digital terintegrasi yang memungkinkan tamu mengirimkan hadiah berupa uang secara online.",
    digital_envelope_list_title: "Pemilik acara akan mendapatkan:",
    digital_envelope_list_1: "Notifikasi realtime setiap ada amplop masuk",
    digital_envelope_list_2: "Riwayat transaksi yang jelas",
    digital_envelope_list_3: "Kemudahan penarikan dana (withdraw)",
    digital_envelope_desc_2: "Semua proses berjalan aman dan transparan.",
    digital_envelope_btn: "Lihat selengkapnya",
    digital_envelope_img_alt: "Amplop Digital Otomatis Elynk",
    physical_gift_title: "Titip Kado Otomatis",
    physical_gift_desc_1: "Tamu dapat memilih dan membeli kado untuk pemilik acara langsung melalui Elynk. Kami yang akan menyiapkan dan mengirimkan kado tersebut ke alamat tujuan.",
    physical_gift_list_title: "Baik tamu maupun pemilik acara akan mendapatkan:",
    physical_gift_list_1: "Informasi pengiriman",
    physical_gift_list_2: "Link tracking secara realtime",
    physical_gift_desc_2: "Tanpa perlu repot koordinasi pengiriman kado secara manual.",
    physical_gift_btn: "Lihat selengkapnya",
    physical_gift_img_alt: "Titip Kado Otomatis Elynk",
    package_price_title: "Pilih Paket Sesuai Kebutuhan Acaramu",
    package_price_desc: "Mulai dari paket Gratis, upgrade kapan saja sesuai kebutuhan",
    select_package_btn: "Pilih Paket",
    faq_title: "Pertanyaan Yang Sering Ditanyakan",
    faq_subtitle: "Semua yang perlu kamu ketahui sebelum menggunakan Elynk.co.",
    faq_q_0: "Apakah ada akses trial?",
    faq_a_0: "Ya, kamu mendapatkan akses trial gratis selama 3 hari untuk mencoba seluruh fitur undangan. Setelah masa trial berakhir, kamu perlu memilih salah satu paket agar undangan tetap aktif. Jika belum memilih paket, undangan akan otomatis terkunci (lock) dan tidak dapat diakses sampai kamu melakukan aktivasi.",
    faq_q_1: "Apakah undangan memiliki batas masa aktif?",
    faq_a_1: "Tidak ada batas masa aktif, jadi undangan kamu tetap bisa diakses selama yang kamu butuhkan. Namun perlu dicatat bahwa satu undangan hanya berlaku untuk satu kali acara, sehingga tidak bisa dipakai ulang atau diganti-ganti untuk acara yang berbeda.",
    faq_q_2: "Apakah bisa upgrade paket kapan saja?",
    faq_a_2: "Bisa, kamu dapat melakukan upgrade paket kapan saja sesuai kebutuhan acaramu, misalnya dari Basic ke Pro atau Premium. Perlu diingat bahwa proses hanya berlaku satu arah, sehingga paket tidak dapat di-downgrade kembali ke tingkat yang lebih rendah setelah di-upgrade.",
    faq_q_3: "Apakah bisa custom tema sesuai desain dari saya?",
    faq_a_3: "Bisa. Untuk kebutuhan desain khusus sesuai keinginanmu, kamu bisa memilih paket Premium yang menyediakan layanan custom design. Tim kami akan membantu mewujudkan tema undangan sesuai konsep dan referensi yang kamu berikan.",
    faq_q_4: "Apakah undangan digital ini hanya khusus pernikahan?",
    faq_a_4: "Tidak. Undangan digital Elynk.co dapat digunakan untuk berbagai jenis acara, seperti ulang tahun, khitanan, aqiqah, wisuda, acara korporasi, hingga gathering keluarga. Kamu bebas menyesuaikan tema dan isi undangan dengan jenis acaramu.",
    faq_q_5: "Bisakah membuat undangan dengan bahasa selain bahasa Indonesia?",
    faq_a_5: "Bisa. Melalui fitur custom localization, kamu dapat membuat undangan dalam bahasa apa pun sesuai kebutuhan, termasuk bahasa asing. Fitur ini bahkan mendukung penggunaan bahasa daerah, sehingga undangan terasa lebih personal dan sesuai dengan latar acaramu.",
    faq_q_6: "Apakah bisa refund pembayaran?",
    faq_a_6: "Bisa. Kamu berhak mendapatkan refund 100% selama undangan belum pernah digunakan atau disebarkan kepada tamu. Apabila undangan sudah aktif dan dibagikan, maka pembayaran tidak dapat dikembalikan.",
    meta_title: "Buat Undangan Digital Gratis 100% & Elegan | Elynk",
    meta_desc: "Bikin undangan digital gratis tanpa biaya di Elynk. Ratusan tema mewah, sebar otomatis ke WhatsApp, & fitur follow-up tamu. Cepat, mudah, dan kekinian!",
    meta_title_price: "Paket Harga Undangan Digital - Elynk.co",
    meta_desc_price: "Pilih paket harga terbaik untuk undangan digitalmu. Tersedia paket gratis selamanya dengan fitur lengkap dan sebar tanpa batas.",
    meta_title_tema: "Katalog Tema Undangan Digital Elegan, Mewah & Modern | Elynk",
    meta_desc_tema: "Pilih ratusan desain undangan digital estetik untuk pernikahan, khitanan, atau acara lainnya. Responsif di HP, loading cepat, dan desain selalu update.",
    no_image: "Gambar belum tersedia",
    produk: "Produk",
    hero_desc_short: "Undangan digital profesional untuk berbagai jenis acara. Gratis digunakan, tanpa masa aktif, dan mudah dikelola.",
    features: {
      "all-in-one-invitation": {
        title: "All-In-One Undangan Digital Platform",
        subtitle: "Solusi Terlengkap dalam Satu Genggaman",
        description: "Buat undangan digital gratis dengan fitur terlengkap. All-in-one platform untuk manajemen tamu, RSVP, hingga kirim kado digital dalam satu aplikasi.",
        seoTitle: "Platform Undangan Digital Gratis Terlengkap di Indonesia",
        seoDesc: "Buat undangan digital gratis dengan fitur terlengkap. All-in-one platform untuk manajemen tamu, RSVP, hingga kirim kado digital dalam satu aplikasi.",
      },
      "whatsapp-broadcast": {
        title: "Sebar Otomatis Via WhatsApp",
        subtitle: "Sebarkan Undangan Lebih Cepat, Rapi, Dan Terstruktur",
        description: "Fitur Sebar Otomatis via WhatsApp di Elynk.co membantu kamu mengirim undangan digital ke banyak tamu tanpa perlu repot mengirim satu per satu secara manual.\n\nCukup siapkan daftar tamu, dan sistem akan membantu proses pengiriman undangan secara otomatis dan terstruktur.",
        seoTitle: "Kirim Undangan Digital via WhatsApp Otomatis & Cepat",
        seoDesc: "Cara sebar undangan digital ke ribuan kontak WhatsApp secara otomatis. Hemat waktu, tanpa manual, dan pastikan undangan sampai ke genggaman tamu.",
      },
      "qr-check-in": {
        title: "QR Code Check-In Buku Tamu",
        subtitle: "Check-in Tamu Lebih Cepat, Rapi, dan Tercatat Otomatis",
        description: "Fitur QR Code Check-in Buku Tamu di Elynk.co membantu proses registrasi kehadiran tamu menjadi lebih tertib dan efisien saat hari acara.\n\nSetiap tamu akan mendapatkan <strong>QR Code unik</strong> yang terhubung langsung dengan data undangan mereka.",
        seoTitle: "Buku Tamu Digital dengan QR Code Check-in Cepat",
        seoDesc: "Modernkan resepsi Anda dengan QR Code Check-in. Buku tamu digital yang mempercepat antrean dan mencatat kehadiran tamu secara akurat dan otomatis",
      },
      "digital-envelope": {
        title: "Amplop Digital Otomatis",
        subtitle: "Terima Amplop Digital Dengan Aman, Praktis, dan Tercatat",
        description: "Fitur Amplop Digital Otomatis di Elynk.co memungkinkan tamu mengirimkan hadiah berupa uang secara online langsung melalui undangan digital.\n\nSemua proses dilakukan dalam satu sistem terintegrasi, sehingga lebih rapi, aman, dan mudah dipantau.",
        seoTitle: "Fitur Amplop Digital: Terima Angpao & Kado via Transfer",
        seoDesc: "Terima kado pernikahan secara cashless dengan Amplop Digital. Aman, praktis, dan langsung masuk ke rekening Anda. Tanpa ribet urus kotak fisik!",
      },
      "custom-rsvp": {
        title: "Apa yang Bisa Kamu Atur?",
        subtitle: "Pertanyaan RSVP Yang Bisa Disesuaikan",
        description: "Kamu Dapat Menentukan Sendiri Pertanyaan RSVP Sesuai Kebutuhan Acara, Seperti:\n\n• Konfirmasi Hadir, Tidak Hadir Atau Ragu\n• Jumlah Tamu Yang Akan Datang\n• Informasi Tambahan Yang Perlu Diketahui Penyelenggara\n\nSemua Pertanyaan Dapat Disesuaikan Agar Data Yang Masuk Benar-Benar Relevan.",
        seoTitle: "Fitur Custom RSVP Undangan Digital Terlengkap",
        seoDesc: "Kelola konfirmasi kehadiran tamu dengan formulir RSVP yang dapat dikustomisasi pertanyaannya sesuai kebutuhan acara.",
      },
      "event-reminders": {
        title: "Reminder Acara Otomatis",
        subtitle: "Pengingat Acara yang Bekerja Otomatis untuk Kamu",
        description: "Reminder acara otomatis di elynk.co memastikan tamu yang sudah mengisi rsvp tidak lupa dengan jadwal acara.\n\nSistem akan mengirimkan pengingat secara otomatis menjelang hari h melalui <strong>WhatsApp</strong> dan <strong>Email</strong>. Kamu tidak perlu lagi mengingatkan tamu satu per satu secara manual.",
        seoTitle: "Fitur Reminder Acara Otomatis: Pastikan Tamu Tak Lupa",
        seoDesc: "Kirim pengingat otomatis kepada tamu H-1 atau beberapa jam sebelum acara dimulai. Tingkatkan kehadiran tamu di hari spesial Anda dengan Elynk",
      },
      "multi-event-access": {
        title: "Split Acara Setiap Tamu",
        subtitle: "Satu Undangan, Banyak Acara dengan Kontrol Penuh",
        description: "Fitur Split Acara Setiap Tamu di Elynk.co memungkinkan kamu membuat beberapa sesi acara dalam satu undangan digital seperti akad, resepsi, after party, atau sesi khusus lainnya.\n\nYang membedakan, <strong>setiap tamu hanya dapat mengakses acara yang memang ditujukan untuknya.</strong>",
        seoTitle: "Manajemen Split Acara: Pisahkan Sesi Tamu Undangan",
        seoDesc: "Atur sesi kehadiran tamu dengan fitur Split Acara. Cocok untuk membagi jadwal tamu VIP atau umum agar lokasi acara tidak terlalu padat (crowd control).",
      },
      "gift-registry": {
        title: "Titip Kado Otomatis",
        subtitle: "Kirim Kado Lebih Praktis, Tanpa Repot Koordinasi",
        description: "Fitur Titip Kado Otomatis di Elynk.co memungkinkan tamu memilih dan membeli kado langsung melalui undangan digital.\n\nElynk yang akan menyiapkan dan mengirimkan kado tersebut ke alamat tujuan. Kamu tidak perlu lagi mengatur pengiriman kado secara manual dengan tamu.",
        seoTitle: "Layanan Titip Kado Otomatis: Kirim Hadiah Tanpa Ribet",
        seoDesc: "Mudahkan tamu yang berhalangan hadir untuk tetap berkirim hadiah melalui fitur Titip Kado Otomatis. Integrasi pengiriman kado langsung ke alamat Anda.",
      }
    },
    price_page_heading: "Harga Undangan Online Di Elynk.Co",
    price_page_subheading: "Temukan paket harga undangan digital yang sesuai dengan kebutuhan Anda! Kami menawarkan berbagai pilihan desain menarik dan fitur lengkap, mulai dari undangan sederhana hingga kustomisasi penuh. Dapatkan layanan terbaik dengan harga terjangkau, termasuk revisi tanpa batas dan dukungan penuh untuk memastikan undangan Anda tampil sempurna. Pilih paket Anda sekarang dan buat momen spesial semakin berkesan!",
    theme_banner_title_1: "Pilih Serta Sesuaikan",
    theme_banner_title_2: "Tema Undanganmu",
    theme_banner_desc: "Gak perlu capek edit-edit tampilan, temanya bisa kalian ubah sesuka hati!",
    filters_btn: "Filters",
    search_theme_placeholder: "Masukkan Nama Tema",
    active_filter_label: "Sedang menerapkan filter:",
    filter_color: "Warna",
    filter_event: "Jenis Acara",
    filter_style: "Style",
    clear_filter_btn: "Hapus Filter",
    recommendation_label: "Rekomendasi",
    search_result_label: "Hasil pencarian:",
    all_themes_label: "Semua Tema",
    design_label: "Desain",
    theme_not_found: "Tema tidak ditemukan.",
    theme_not_found_desc: "Coba gunakan kata kunci atau filter lain.",
    filter_modal_title: "Filter Tema",
    filter_category_label: "Kategori Acara",
    all_categories: "Semua Kategori",
    filter_style_label: "Tipe Style",
    all_styles: "Semua Tipe",
    filter_color_label: "Warna",
    reset_btn: "Reset",
    apply_filter_btn: "Terapkan Filter",
    preview_not_available: "Mohon maaf, Preview/Demo belum tersedia untuk tema ini.",
    menu_footer_title: "Menu",
  },
  Login: {
    hero_title: "Undangan Digital Profesional No.1 Di Indonesia. Untuk Segala Jenis Acara 100% GRATIS",
    hero_desc: "Kelola undangan, RSVP, pengingat acara, hingga amplop digital dalam satu platform yang rapi, otomatis, dan gratis tanpa batas.",
    welcome_back: "Selamat Datang Kembali",
    please_login: "Silakan login ke akun Anda",
    email_label: "Alamat Email",
    email_placeholder: "nama@domain.com",
    email_required: "Masukkan email terlebih dahulu...",
    email_invalid: "Format email tidak valid",
    password_label: "Kata Sandi",
    password_required: "Masukkan password terlebih dahulu...",
    forgot_password: "Lupa Kata Sandi?",
    login_btn: "Masuk",
    logging_in: "Sedang masuk...",
    or_login_with: "Atau Masuk Dengan",
    redirecting: "Mengarahkan...",
    google_btn: "Google",
    no_account: "Belum punya akun?",
    register_link: "Daftar",
    welcome_back_toast: "Selamat datang kembali!",
    login_failed_toast: "Email atau password salah",
    google_error_toast: "Gagal mengalihkan ke Google."
  },
  Register: {
    hero_title: "Undangan Digital Profesional No.1 Di Indonesia. Untuk Segala Jenis Acara 100% GRATIS",
    hero_desc: "Kelola undangan, RSVP, pengingat acara, hingga amplop digital dalam satu platform yang rapi, otomatis, dan gratis tanpa batas.",
    create_account: "Buat Akun Anda",
    name_label: "Nama Lengkap",
    name_placeholder: "Jhon Doe",
    email_label: "Alamat Email",
    email_placeholder: "username@domain.com",
    password_label: "Buat Kata Sandi",
    confirm_label: "Konfirmasi Kata Sandi",
    agree_to: "Saya setuju dengan",
    terms_conditions: "Syarat & Ketentuan",
    register_btn: "Daftar",
    or_register_with: "Atau Daftar Menggunakan",
    redirecting: "Mengarahkan...",
    google_btn: "Daftar dengan Google",
    creating_account: "Sedang membuat akun...",
    or_login_with: "Atau Daftar Dengan",
    already_have_account: "Sudah punya akun?",
    login_link: "Masuk",
    error_name_required: "Masukkan Nama terlebih dahulu...",
    error_name_min: "Nama minimal 2 karakter",
    error_name_invalid: "Nama hanya boleh mengandung huruf dan spasi",
    error_email_required: "Masukkan email terlebih dahulu...",
    error_email_invalid: "Masukkan email yang valid",
    error_password_required: "Masukkan password terlebih dahulu...",
    error_password_min: "Password minimal 8 karakter",
    error_confirm_required: "Harap konfirmasi password Anda...",
    error_password_mismatch: "Password tidak sama",
    error_terms_required: "Wajib menyetujui syarat dan ketentuan terlebih dahulu...",
    success_registration_toast: "Registrasi sukses! Menyiapkan akun Anda...",
    success_login_toast: "Berhasil masuk!",
    error_auto_login_toast: "Registrasi berhasil, namun otomatis login gagal. Silakan login manual.",
    error_registration_failed_toast: "Registrasi gagal",
    google_coming_soon: "Fitur Google Login segera hadir! 🚀",
  },
  ForgotPassword: {
    page_title: "Lupa Kata Sandi",
    hero_title: "Undangan Digital Profesional No.1 Di Indonesia. Untuk Segala Jenis Acara 100% GRATIS",
    hero_desc: "Kelola undangan, RSVP, pengingat acara, hingga amplop digital dalam satu platform yang rapi, otomatis, dan gratis tanpa batas.",
    form_title: "Lupa Kata Sandi?",
    form_desc_1: "Masukkan alamat email Anda di bawah ini dan kami akan",
    form_desc_2: "mengirimkan tautan untuk mengatur ulang kata sandi Anda.",
    email_placeholder: "Alamat Email",
    timer_sec: "Detik",
    btn_send_link: "Kirim Tautan Atur Ulang",
    btn_sending: "Mengirim...",
    btn_wait: "Tunggu sebelum mengirim ulang...",
    back_to: "Kembali ke",
    login_link: "Masuk",
    error_email_required: "Masukkan email terlebih dahulu...",
    error_email_invalid: "Format email tidak valid",
    success_toast: "Tautan atur ulang berhasil dikirim ke email Anda!",
    error_toast: "Gagal mengirim tautan atur ulang."
  },
  ResetPassword: {
    form_title: "Atur Ulang Kata Sandi",
    form_subtitle: "Masukkan kata sandi baru Anda di bawah ini",
    label_new: "Kata Sandi Baru",
    label_confirm: "Konfirmasi Kata Sandi",
    btn_reset: "Atur Ulang Kata Sandi",
    btn_resetting: "Sedang mengatur ulang...",
    back_to: "Kembali ke",
    login_link: "Masuk",
    already_done_title: "Reset Password Selesai",
    already_done_desc: "Akun Anda ({email}) sudah melakukan reset password sebelumnya. Anda tidak dapat melakukan reset ulang saat ini.",
    error_required: "Semua kolom password wajib diisi.",
    error_min: "Password minimal harus 8 karakter.",
    error_mismatch: "Password dan Konfirmasi Password tidak cocok.",
    success_toast: "Password berhasil direset! Silakan login.",
    error_toast: "Gagal mereset password.",
    back_to_login: "Kembali ke Login"
  },
  AllInOne: {
    hero_title: "All-In-One Undangan Digital Platform (Gratis)",
    hero_subtitle: "Semua Fitur Dasar Undangan Digital, Sudah Termasuk",
    hero_desc: "adalah platform undangan digital yang dirancang agar kamu bisa membuat undangan dengan <b>lengkap</b>, <b>rapi</b>, dan <b>profesional</b>, tanpa perlu biaya dan tanpa batas waktu. <br/>",
    list_heading: "Semua fitur dasar undangan digital sudah tersedia dan bisa langsung digunakan:",
    list_item_1: "Gratis",
    list_item_2: "Bisa Disebar Unlimited",
    list_item_3: "Tanpa Masa Aktif",
    no_upgrade_needed: "Kamu tidak perlu upgrade hanya untuk menggunakan fitur penting undangan.",
    btn_create: "Buat Gratis Sekarang",
    meaning_title: "Apa Maksudnya All-In-One?",
    meaning_desc: "All-in-One berarti kamu tidak perlu menggabungkan banyak tools atau layanan lain. Semua kebutuhan undangan digital, mulai dari tampilan, informasi acara, hingga pengalaman tamu sudah tersedia dalam satu platform. Cukup buat satu undangan, isi data, pilih tema, dan sebarkan.",
    feature_20_title: "20+ Fitur Undangan Digital Yang Kamu Dapatkan",
    feat_l_1: "Bebas ganti ke semua tema",
    feat_l_2: "Ubah nama tamu unlimited",
    feat_l_3: "Tanpa masa aktif",
    feat_l_4: "RSVP & ucapan",
    feat_l_5: "Terintegrasi Google Maps",
    feat_l_6: "Sebar ke unlimited penerima",
    feat_l_7: "Countdown menuju hari-H",
    feat_l_8: "Pengingat Google Calendar",
    feat_l_9: "Foto galeri & video",
    feat_l_10: "Rekening titip hadiah",
    feat_l_11: "Titip kado fisik ke acara",
    feat_l_12: "Amplop digital di undangan",
    feat_l_13: "Ratusan musik bisa custom",
    feat_r_1: "Link live streaming",
    feat_r_2: "Fitur auto scroll",
    feat_r_3: "Ubah font dan warna tulisan",
    feat_r_4: "Kustomisasi tema undangan",
    feat_r_5: "QR code buku tamu",
    feat_r_6: "Layar sapa & check-in tamu",
    feat_r_7: "Love story & susunan acara",
    feat_r_8: "Fitur turut mengundang",
    feat_r_9: "Laporan statistik sebar",
    feat_r_10: "Embed map lokasi acara",
    feat_r_11: "Balas ucapan tamu",
    feat_r_12: "Unlimited revisi sepuasnya",
    feat_r_13: "Ubah susunan komponen",
    free_box_title: "Gratis, Unlimited,<br/>Tanpa Masa Aktif",
    free_box_subtitle: "Semua fitur undangan digital di atas:",
    free_box_list_1: "Gratis digunakan",
    free_box_list_2: "Bisa disebar unlimited",
    free_box_list_3: "Tanpa masa aktif",
    use_elynk_1: "Gunakan",
    use_elynk_2: "tanpa batasan waktu dan tanpa biaya tersembunyi."
  },
  AutoShare: {
    how_it_works: "Bagaimana cara kerjanya?",
    step1_title: "Siapkan Daftar Tamu",
    step1_desc: "Masukkan daftar tamu berserta nomor whatsapp mereka ke dalam sistem",
    step2_title: "Atur Pesan Undangan",
    step2_desc: "Tentukan format pesan undangan yang ingin dikirim, lengkap dengan link undangan personal untuk setiap tamu",
    step3_title: "Sebar otomatis",
    step3_desc_1: "Sistem elynk akan mengirim undangan secara bertahap dan terkontrol melalui whatsapp.",
    step3_desc_2: "Semua proses berjalan tanpa perlu intervensi manual",
    benefits_title: "Apa keunggulannya?",
    benefits_subtitle: "Proses Sebar Undangan Lebih Cepat",
    benefits_desc: "Pengiriman undangan ke ratusan hingga ribuan tamu dapat dilakukan dalam waktu singkat.",
    card1_title: "Minim Kesalahan Pengiriman",
    card1_desc: "Karena proses dilakukan oleh sistem, risiko:",
    card1_li_1: "Salah kirim pesan",
    card1_li_2: "Salah link undangan",
    card1_li_3: "Lupa mengirim ke tamu tertentu dapat diminimalkan.",
    card2_title: "Efisien untuk Banyak Tamu",
    card2_desc: "Fitur ini sangat ideal untuk:",
    card2_li_1: "Acara dengan jumlah tamu besar",
    card2_li_2: "Event profesional atau corporate",
    card2_li_3: "Pengguna yang ingin menghemat waktu dan tenaga",
    card3_title: "Terstruktur & Tercatat",
    card3_desc: "Setiap proses pengiriman undangan tercatat dalam sistem, sehingga kamu dapat:",
    card3_li_1: "Mengetahui undangan yang sudah terkirim",
    card3_li_2: "Memantau progres pengiriman",
    card3_li_3: "Mengelola daftar tamu dengan lebih rapi",
    card4_title: "Terintegrasi dengan Fitur Lain",
    card4_desc: "Sebar otomatis via whatsapp terhubung langsung dengan:",
    card4_li_1: "Custom rsvp",
    card4_li_2: "Reminder acara otomatis",
    card4_li_3: "Laporan statistik sebar",
    card4_footer: "Semua data bekerja saling terhubung untuk mendukung kelancaran acara."
  },
  QRCheckin: {
    how_it_works: "Bagaimana cara kerjanya?",
    step1_title: "QR Code untuk Setiap Tamu",
    step1_desc: "Setiap undangan dilengkapi QR Code unik yang hanya berlaku untuk tamu tersebut.",
    step2_title: "Scan di Lokasi Acara",
    step2_desc: "Saat tiba di lokasi, tamu cukup menunjukkan QR Code untuk dipindai oleh panitia.",
    step3_title: "Kehadiran Tercatat Otomatis",
    step3_desc: "Setelah QR Code dipindai, kehadiran tamu langsung tercatat di sistem secara realtime.",
    why_use_title: "Kenapa Menggunakan<br/>QR Code Check-In?",
    without_qr_desc: "Tanpa Sistem Check-In Digital, sering terjadi:",
    without_qr_li_1: "Antrean panjang di pintu masuk",
    without_qr_li_2: "Kesalahan pencatatan tamu",
    without_qr_li_3: "Sulit mengetahui jumlah tamu yang sudah hadir",
    qr_solves_desc: "QR Code Check-In membantu mengatasi masalah tersebut.",
    main_benefits_title: "Keuntungan utama",
    benefit1_title: "Proses Check-In Lebih Cepat & Tertib",
    benefit1_desc: "Tamu tidak perlu menulis manual atau menunggu lama, sehingga alur masuk acara lebih lancar.",
    benefit2_title: "Data kehadiran Tercatat Otomatis",
    benefit2_desc: "Setiap tamu yang hadir langsung tercatat di sistem, tanpa input manual dari panitia.",
    benefit3_title: "Cocok untuk Acara Formal & Profesional",
    benefit3_desc: "Fitur ini sangat ideal untuk:",
    benefit3_li_1: "Pernikahan dengan banyak tamu",
    benefit3_li_2: "Intimate Wedding dengan kontrol tamu",
    benefit3_li_3: "Event Profesional dan Corporate",
    benefit4_title: "Terintegrasi dengan Sistem Undangan",
    benefit4_desc: "QR Code Check-In buku tamu terhubung langsung dengan:",
    benefit4_li_1: "Custom RSVP",
    benefit4_li_2: "Reminder Acara Otomatis",
    benefit4_li_3: "Laporan kehadiran tamu",
    benefit4_footer: "Semua data kehadiran tersimpan rapi dalam satu platform."
  },
  EventReminder: {
    how_it_works: "Bagaimana cara kerjanya?",
    step1_title: "Tamu Mengisi RSVP",
    step1_desc: "Hanya tamu yang sudah mengonfirmasi kehadiran yang akan menerima pengingat.",
    step2_title: "Pengingat Dikirim Otomatis",
    step2_desc: "Sistem akan mengirimkan reminder secara otomatis sesuai jadwal yang telah ditentukan.",
    step3_title: "Melalui Whatsapp & Email",
    step3_desc: "Pengingat dikirim melalui dua kanal utama untuk memastikan pesan tersampaikan dengan baik.",
    why_important_title: "Kenapa Fitur ini penting?",
    without_reminder_desc: "Tanpa pengingat, sering terjadi:",
    problem_1: "Tamu lupa tanggal<br/>atau jam acara",
    problem_2: "Kehadiran tidak sesuai<br/>dengan konfirmasi",
    problem_3: "Penyelenggara harus<br/>melakukan follow-up manual",
    solution_desc: "Reminder Acara Otomatis membantu<br /> mengatasi semua hal tersebut.",
    main_benefits_title: "Manfaat utama",
    card1_title: "Mengurangi Tamu yang<br class='hidden md:block' /> Lupa Hadir",
    card1_desc: "Tamu mendapatkan pengingat tepat waktu sehingga lebih siap menghadiri acara.",
    card2_title: "Meningkatkan Tingkat<br class='hidden md:block' /> Kehadiran",
    card2_desc: "Dengan reminder yang konsisten, kemungkinan tamu benar-benar datang sesuai rsvp menjadi lebih tinggi.",
    card3_title: "Tanpa Follow-up Manual",
    card3_desc_1: "Kamu tidak perlu lagi:",
    card3_li_1: "Mengirim pesan pengingat satu per satu",
    card3_li_2: "Menghubungi tamu menjelang hari acara",
    card3_desc_2: "Semua sudah diurus oleh sistem.",
    card4_title: "Terintegrasi dengan Sistem Undangan",
    card4_desc_1: "Reminder acara otomatis bekerja selaras dengan:",
    card4_li_1: "Custom RSVP",
    card4_li_2: "Sebar otomatis via whatsapp",
    card4_li_3: "Qr code check-in buku tamu",
    card4_desc_2: "Data kehadiran dan pengingat selalu sinkron dalam satu sistem.",
    card5_title: "Cocok Digunakan Untuk",
    card5_li_1: "Pernikahan & intimate wedding",
    card5_li_2: "Acara keluarga",
    card5_li_3: "Event komunitas",
    card5_li_4: "Acara profesional & korporasi",
    card5_desc: "Fitur ini membantu semua jenis acara berjalan lebih tertib."
  },
  MultiEvent: {
    how_it_works: "Bagaimana Cara Kerjanya?",
    step1_title: "Buat Beberapa Acara dalam Satu Undangan",
    step1_desc: "Kamu dapat menambahkan lebih dari satu acara dengan waktu, lokasi, dan detail yang berbeda.",
    step2_title: "Atur Akses Setiap Tamu",
    step2_desc: "Tentukan tamu mana yang diundang ke acara tertentu dan tidak ke acara lainnya.",
    step3_title: "Undangan Ditampilkan Secara Personal",
    step3_desc: "Tamu hanya melihat informasi acara yang memang relevan untuk mereka.",
    why_important_title: "Kenapa Fitur Ini Penting?",
    without_feature_desc: "Tanpa pengaturan akses, sering terjadi:",
    problem_1: "Tamu hadir di acara yang bukan untuknya",
    problem_2: "Kebingungan jadwal dan lokasi",
    problem_3: "Kurangnya privasi untuk sesi tertentu",
    solution_desc: "Split Acara membantu semua itu tetap terkontrol.",
    main_benefits_title: "Manfaat Utama",
    card1_title: "Kontrol Akses Acara",
    card1_desc: "Setiap tamu hanya dapat menghadiri acara yang memang diperuntukkan untuk mereka.",
    card2_title: "Lebih Rapi & Profesional",
    card2_desc: "Undangan terasa lebih tertata karena setiap tamu menerima informasi yang relevan.",
    card3_title: "Privasi Lebih Terjaga",
    card3_desc: "Sesi tertentu seperti akad atau acara terbatas tetap eksklusif.",
    card4_title: "Sangat Cocok untuk",
    card4_li_1: "Acara dengan segmentasi tamu",
    card4_li_2: "Intimate wedding dengan kapasitas terbatas",
    card4_li_3: "Event profesional yang memerlukan kontrol akses",
    card5_title: "Terintegrasi dengan Fitur Lain",
    card5_desc: "Split Acara Setiap Tamu terhubung langsung dengan:",
    card5_li_1: "Custom RSVP",
    card5_li_2: "QR Code Check-in Buku Tamu",
    card5_li_3: "Reminder Acara Otomatis",
    card5_footer: "Data kehadiran dan akses acara selalu sinkron."
  },
  GiftRegistry: {
    how_it_works: "Bagaimana Cara Kerjanya?",
    step1_title: "Tamu Memilih Kado",
    step1_desc: "Tamu dapat memilih kado yang tersedia langsung dari undangan digital.",
    step2_title: "Kado Disiapkan oleh Elynk",
    step2_desc: "Setelah pembelian, Elynk akan menyiapkan kado sesuai pesanan.",
    step3_title: "Pengiriman ke Alamat Tujuan",
    step3_desc: "Kado dikirim langsung ke alamat pemilik acara atau alamat yang telah ditentukan.",
    transparent_title: "Transparan & Mudah Dipantau",
    transparent_desc_1: "Baik tamu maupun pemilik acara akan mendapatkan:",
    transparent_li_1: "Informasi status pengiriman",
    transparent_li_2: "Link tracking kado secara realtime",
    transparent_desc_2: "Semua pihak bisa memantau proses pengiriman tanpa perlu bertanya satu sama lain.",
    main_benefits_title: "Keuntungan Utama",
    card1_title: "Tanpa Koordinasi Manual",
    card1_desc_1: "Tidak perlu lagi:",
    card1_li_1: "Bertanya alamat pengiriman",
    card1_li_2: "Mengatur kurir secara terpisah",
    card1_li_3: "Mengonfirmasi status pengiriman satu per satu",
    card1_desc_2: "Semua sudah diurus oleh sistem.",
    card2_title: "Pengalaman Tamu Lebih Nyaman",
    card2_desc: "Tamu bisa memberikan kado meskipun tidak hadir secara langsung di acara.",
    card3_title: "Lebih Rapi untuk Pemilik Acara",
    card3_desc: "Pemilik acara menerima kado dengan pengiriman yang terorganisir dan tercatat.",
    card4_title: "Cocok Digunakan Untuk",
    card4_li_1: "Pernikahan & acara keluarga",
    card4_li_2: "Acara dengan tamu di luar kota",
    card4_li_3: "Event profesional & corporate",
    card4_li_4: "Acara dengan jumlah tamu besar",
    card5_title: "Terintegrasi dengan Sistem Undangan",
    card5_desc_1: "Titip Kado Otomatis terhubung langsung dengan:",
    card5_li_1: "Amplop Digital Otomatis",
    card5_li_2: "Sebar otomatis via WhatsApp",
    card5_li_3: "Dashboard laporan hadiah",
    card5_desc_2: "Semua hadiah tercatat rapi dalam satu sistem."
  },
  MenuTypeSetting: {
    description: "Pilih tampilan menu navigasi yang muncul di undangan.",
    default_name: "Default",
    default_desc: "Menu melayang dengan foto sampul.",
    liquid_glass_desc: "Menu transparan dengan efek kaca cair.",
    load_failed: "Gagal memuat daftar tipe menu.",
    save: "Simpan Perubahan",
    saving: "Menyimpan...",
    save_success: "Tipe menu berhasil diperbarui.",
    save_failed: "Gagal menyimpan tipe menu."
  },
  InvitationMenu: {
    event_label: "Acara",
    rsvp_label: "RSVP",
    hadiah_label: "Hadiah",
    physical_gift_label: "Gift",
    language_label: "Bahasa",
    wish_label: "Ucapan",
    qr_label: "QR Code",
    gift_label: "Hadiah",
    scroll_label: "Scroll",
    gift_modal_title: "Pilih Kado Fisik"
  },
  MenuPanel: {
    edit_box: "Edit Box",
    tab_components: "Komponen",
    tab_settings: "Setting",
    tab_preview: "Pratinjau",
    tab_upgrade: "Upgrade",
    tab_share: "Sebar",
    edit: "Edit",
    edit_background: "Edit Latar Belakang",
    edit_box_art: "Edit Box Art",
    under_maintenance: "sedang dalam perbaikan",
    preview_title: "Pratinjau",
    preview_desc: "Lihat pratinjau undangan",
    activation_title: "Aktivasi",
    activation_desc: "Aktivasi undangan Anda",
    share_title: "Sebar",
    share_desc: "Bagikan undangan Anda"
  },
  SortableBox: {
    edit_box: "Edit Box",
    delete_box: "Hapus Box",
    show_box: "Tampilkan Box",
    drag_placeholder: "Tarik komponen ke box ini",
    add_component: "Tambah Komponen"
  },
  SettingsRealtimeEdit: {
    menu_theme: "Tema",
    menu_music: "Musik",
    menu_colors: "Warna Tema",
    menu_fonts: "Font Tema",
    menu_autoscroll: "Auto Scroll",
    menu_menu_type: "Tipe Menu",
    menu_whatsapp: "Preview WhatsApp",
    desc_whatsapp: "Lihat bagaimana tampilan undangan di WhatsApp"
  },
  PhysicalGift: {
    error_min_gift: "Pilih minimal 1 kado.",
    error_invitation_not_ready: "Data undangan belum siap. Silakan refresh halaman."
  },
  CheckoutGift: {
    title: "Pilih Kado Lain",
    info_banner: "Setelah pembayaran, tamu undangan akan mendapatkan notifikasi dan tim kami akan menyiapkan dan mengirimkan kado sesuai konfirmasi pemilik acara. Tamu undangan akan mendapatkan <strong>link tracking</strong> untuk memantau status dari kado yang diberikan.",
    items_title: "Items",
    aria_remove_item: "Hapus {name}",
    payment_summary_title: "Ringkasan Pembayaran",
    total_purchase: "Total Pembelian",
    shipping_paid_by_recipient: "Ongkir ditanggung penerima",
    shipping: "Ongkir",
    shipping_discount: "Diskon Ongkir",
    total_payment: "Total Pembayaran",
    greeting_section_title: "Ucapan (Opsional)",
    greeting_label: "Ucapan",
    greeting_placeholder: "Tulis ucapan untuk pengantin",
    agree_terms_label: "Saya menyetujui kebijakan layanan dari elynk.co",
    agree_terms_error: "Anda harus menyetujui kebijakan layanan terlebih dahulu",
    privacy_note: "Data Anda dijaga kerahasiaannya dan hanya akan digunakan untuk tujuan konfirmasi",
    footer_info: "Setelah pembayaran Anda akan mendapatkan link tracking via email",
    total_label: "Total",
    btn_proceed_payment: "Lanjut ke Pembayaran",
    toast_success: "Data checkout disimpan, silakan lanjutkan pembayaran.",
    toast_error: "Terjadi kesalahan, silakan coba lagi."
  },
  ListGiftProduct: {
    info_banner: "Titip Kado Fisik memungkinkan tamu mengirimkan kado langsung dari Undangan Digital. Setelah pembayaran terkonfirmasi, pemilik acara akan mendapatkan <span class='font-bold'>notifikasi</span>, tim kami akan menyiapkan dan mengirimkan kado sesuai konfirmasi pemilik acara. Tamu undangan akan mendapatkan <span class='font-bold'>link tracking</span> untuk memantau status dari kado yang diberikan.",
    aria_view_detail: "Lihat detail",
    btn_selected: "Terpilih",
    btn_select_gift: "Pilih Kado",
    footer_info: "Setelah pembayaran Anda akan mendapatkan link tracking via email",
    total: "Total",
    btn_proceed_payment: "Lanjut ke Pembayaran"
  },
  LayarSapa: {
    waiting_guest: "Menunggu Tamu...",
    welcome: "Selamat Datang",
    thank_you: "Terima Kasih Telah Hadir di Acara Kami",
    dear: "Kepada Yth:"
  },
  GuestQR: {
    page_title: "Tiket QR Code Tamu",
    default_event_name: "Undangan Pernikahan",
    success_download: "Tiket QR Code berhasil diunduh!",
    error_download: "Gagal mengunduh QR Code.",
    invalid_qr: "QR Code Tidak Valid",
    invalid_qr_desc: "Link undangan tidak memiliki Kode Tamu.",
    btn_back: "Kembali",
    scan_title: "Scan Check-in Buku Tamu",
    view_invitation: "Lihat Undangan",
    scan_instruction: "Tunjukkan QRCode ini kepada panitia acara sebelum memasuki venue (Tempat Acara)",
    btn_download: "Download"
  },
  GuestQrCamera: {
    btn_back: "Kembali",
    page_title: "Scan QR Undangan",
    page_instruction: "Silakan arahkan kamera Anda ke kode QR yang tertera pada undangan untuk melakukan absensi.",
    box_instruction: "Posisikan kode QR di dalam kotak",
    status_validating: "Memvalidasi Data Acara...",
    status_camera_init: "Menyiapkan Kamera...",
    status_processing: "Memproses Check-in...",
    status_wait: "Mohon tunggu sebentar",
    error_event_not_found: "Data acara tidak ditemukan!",
    error_missing_code: "Kode Tamu tidak ditemukan di URL! Buka menu QR Code dari Undangan.",
    error_invalid_qr: "QR Code tidak sesuai. Scan QR Code yang diletakkan di pintu masuk acara!",
    loading_verify_location: "Memverifikasi Lokasi Anda...",
    info_already_checked_in: "Anda sudah Check-in sebelumnya",
    info_redirecting: "Mengarahkan ke halaman sukses.",
    success_location_match: "Lokasi Sesuai! Lanjut konfirmasi.",
    error_fetch_data: "Gagal menarik data tamu. Coba lagi.",
    error_camera_access: "Gagal akses kamera. Pastikan browser memiliki izin kamera."
  },
  GuestSubmit: {
    guest_name_default: "Tamu",
    toast_error_corrupt: "Link data tamu rusak.",
    event_name_default: "Acara Kami",
    toast_error_session: "Sesi tidak valid. Silakan scan ulang.",
    toast_success_checkin: "Check-in Berhasil!",
    toast_error_checkin: "Gagal memproses Check-in. Silakan coba lagi.",
    toast_error_incomplete: "Data tidak lengkap. Mengembalikan ke kamera...",
    btn_cancel: "Batal Scan",
    title: "Konfirmasi Kehadiran",
    location_notice: "Anda terdeteksi berada di lokasi acara.<br/>Pastikan jumlah rombongan yang Anda bawa sesuai sebelum menekan check-in.",
    subtitle: "Self Check-in Tamu",
    label_name: "Nama Anda",
    label_pax: "Total Rombongan Hadir",
    label_pax_unit: "Orang",
    btn_processing: "Memproses...",
    btn_submit: "Selesaikan Check-in",
  },
  GuestSuccess: {
    page_title: "Sukses Check-in",
    success_title: "BERHASIL CHECK-IN",
    seconds: "Detik",
    success_desc: "Selamat Anda sudah berhasil scan QRCode<br/>untuk Check-in ke dalam Venue",
    btn_back: "Kembali Ke Undangan"
  },

  AdminSubmitCheckin: {
    page_title: "Konfirmasi Check-in",
    toast_error_corrupt: "Link data tamu rusak.",
    event_name_default: "Undangan Pernikahan",
    toast_error_session: "Data ID tidak valid / Session berakhir",
    toast_success_checkin: "berhasil Check-in!",
    toast_success_desc: "Terima kasih atas konfirmasi Anda.",
    toast_error_update: "Gagal update data. (Pastikan scan kamera sudah memanggil API POST sebelumnya).",
    toast_error_incomplete: "Data URL tidak lengkap.",
    btn_back: "Kembali ke Scanner",
    title: "Submit Buku Tamu",
    valid_qr_notice: "Data QR Code Valid!<br/>Pastikan jumlah rombongan sesuai sebelum menekan submit.",
    view_invitation: "Lihat Undangan",
    label_name: "Nama Tamu",
    label_pax: "Total Hadir",
    label_pax_unit: "Orang",
    btn_processing: "Menyimpan Data...",
    btn_submit: "Submit Checkin"
  },
  AdminQrCamera: {
    toast_wrong_event: "QR Code ini untuk acara lain!",
    toast_verifying: "Memverifikasi Tamu...",
    toast_already_checked_in: "Tamu sudah Check-in sebelumnya",
    toast_redirecting: "Mengarahkan ke layar sukses.",
    toast_qr_valid: "QR Valid! Lanjut konfirmasi.",
    toast_invalid_qr: "QR Code Tidak Valid",
    toast_camera_error: "Gagal akses kamera. Pastikan browser memiliki izin kamera.",
    btn_back: "Kembali",
    title: "Scan QRCode Tamu",
    instruction: "Arahkan kamera ke QRCode yang dibawa oleh Tamu Undangan",
    status_validating: "Memvalidasi Data Acara...",
    status_camera_init: "Menyiapkan Kamera...",
    status_processing: "Memproses Check-in..."
  },
  AdminSuccess: {
    page_title: "Sukses Check-in",
    success_title: "BERHASIL CHECK-IN",
    seconds: "Detik",
    success_desc: "Tamu berhasil dikonfirmasi.<br/>Mengarahkan kembali ke Scanner Kamera...",
    btn_next_scan: "Lanjut Scan Berikutnya"
  },
  Notification: {
    notifikasi: "Notifikasi",
    tandai_semua_dibaca: "Tandai semua dibaca",
    memuat: "Memuat...",
    belum_ada_pemberitahuan: "Belum ada pemberitahuan",
    detail_pemberitahuan: "Detail Pemberitahuan",
    judul: "Judul",
    isi_pesan: "Isi Pesan",
    tutup: "Tutup",
    baru_saja: "Baru saja",
    menit_lalu: "mnt lalu",
    jam_lalu: "jam lalu",
    hari_lalu: "hari lalu"
  },
  AddEvent: {
    title: "Buat Undangan Digital",
    subtitle: "Pilih Jenis Acara",
    auth_ready_notice: "Undangan kamu sudah siap — masuk untuk menyimpannya.",
    step: "Langkah 1 dari 5",
    default_desc: "Custom undangan untuk semua jenis acara",
    fill_data_subtitle: "Isi Beberapa Data",
    step_2: "Langkah 2 dari 5",
    note_adjustable: "Note: Semua Data Bisa Disesuaikan Lagi Nanti",
    digital_invitation: "Undangan Digital",
    your_event: "Acara Anda",
    subtitle_theme: "Pilih Tema Undangan",
    step_3: "Langkah 3 dari 5",
    note_theme_adjustable: "Note: Tema dapat diubah kembali kapan saja melalui dashboard.",
    auth_subtitle: "Masuk Untuk Melanjutkan",
    submit_auth_btn: "Masuk & Lanjutkan",
    step_4: "Langkah 4 dari 5",
    auth_ready_title: "Undangan Kamu Sudah Siap",
    auth_ready_desc: "Masuk Untuk Menyimpan dan Melanjutkan",
    invitation_label: "Undangan",
    name_label: "Nama",
    date_label: "Tanggal",
    theme_label: "Tema",
    theme_loading: "Memuat Tema...",
    selected_theme: "Tema Terpilih",
    loading: "Memuat...",
    auth_google_btn: "Lanjutkan dengan Google",
    auth_email_btn: "Lanjutkan dengan Email",
    subtitle_pricing: "Pilih Paket Harga",
    step_5: "Langkah 5 dari 5",
    agreement_text: "Dengan membuat acara, user dinyatakan bersedia mengikuti ",
    btn_create_invitation: "Buat Undangan",
    data_security_notice: "Data kamu aman & hanya dipakai untuk undangan ini.",
  },
  Auth: {
    keluar: "Keluar",
    keluar_proses: "Sedang keluar...",
    send_otp_title: "Kirim Kode Verifikasi",
    send_otp_heading: "Verifikasi Akun",
    send_otp_desc: "Masukkan email Anda untuk menerima kode verifikasi OTP.",
    email_label: "Alamat Email",
    email_required: "Masukkan alamat email terlebih dahulu.",
    send_otp_btn: "Kirim Kode OTP",
    verify_email_title: "Verifikasi Email",
    verify_email_heading: "Verifikasi Email",
    verify_email_desc: "Kami telah mengirim kode 6 digit ke email Anda",
    verify_btn: "Verifikasi",
    verifying: "Memverifikasi...",
    resend_code_now: "Kirim ulang kode sekarang",
    resending: "Mengirim ulang...",
    resend_code_in: "Kirim ulang kode dalam",
    otp_incomplete: "Masukkan 6 digit kode OTP secara lengkap.",
    email_not_found: "Email tidak ditemukan.",
    verify_success: "Verifikasi email berhasil!",
    otp_resent: "Kode OTP baru telah dikirim ke email Anda.",
    otp_invalid_or_expired: "Kode OTP salah atau sudah kedaluwarsa.",
    otp_resend_failed: "Gagal mengirim ulang kode OTP.",
  },
  Checkout: {
    data_tidak_ditemukan: "Data transaksi tidak ditemukan",
    lengkapi_data: "Mohon lengkapi Nama, Email, dan Whatsapp.",
    error_data_order: "Terjadi kesalahan data order.",
    invoice_berhasil: "Invoice berhasil dibuat, mengalihkan...",
    gagal_link: "Gagal mendapatkan link pembayaran.",
    gagal_proses: "Gagal memproses pembayaran. Silakan coba lagi.",

    item_title: "Item",
    paket_topup_ai: "Paket Top Up AI",
    paket_limit_sebar: "Paket Limit Sebar",
    kredit: "Kredit",
    pesan: "Pesan",

    ringkasan_pembayaran: "Ringkasan Pembayaran",
    kredit_ai: "Kredit AI",
    paket_limit: "Paket Limit",
    biaya_layanan: "Biaya Layanan",
    total_pembayaran: "Total Pembayaran",

    checkout_title: "Checkout",
    nama_lengkap: "Nama Lengkap",
    placeholder_nama: "Masukkan nama Anda...",
    email: "Email",
    placeholder_email: "Masukkan email Anda..",
    nomor_whatsapp: "Nomor Whatsapp",
    placeholder_whatsapp: "Masukkan nomor Whatsapp Anda...",

    memproses: "Memproses Invoice...",
    lanjut_pembayaran: "Lanjut Pembayaran",
    payment_summary: "Ringkasan Pembayaran",
    current_package_discount: "Potongan Paket Saat Ini",
    service_fee: "Biaya Layanan",
    total_payment: "Total Pembayaran",
    full_name: "Nama Lengkap",
    whatsapp: "Nomor Whatsapp",
    search_country: "Cari negara atau kode...",
    country_not_found: "Negara tidak ditemukan",
    proceed_payment: "Lanjut Pembayaran",
    loading_package: "Memuat Paket...",
    redirect_payment: "Mengarahkan ke halaman pembayaran...",
    checkout_success: "Checkout berhasil dicatat!",
    fill_required: "Mohon lengkapi Nama, Email, dan Whatsapp.",
    promo_title: "Punya Kode Promo?",
    promo_placeholder: "Masukkan kode kupon...",
    promo_apply: "Terapkan",
    promo_success: "Kupon berhasil dipasang!",
    promo_invalid: "Kupon tidak valid.",
    promo_removed: "Kupon telah dilepas.",
    promo_active: "Kupon Aktif!",
    promo_discount: "Diskon Promo"
  },
  CheckoutSuccess: {
    title: "Pembayaran Berhasil",
    subtitle: "Selamat! Pembayaran Anda sudah berhasil tervalidasi",
    redirecting_in: "Mengalihkan otomatis dalam",
    seconds: "detik...",
    waiting_data: "Menunggu konfirmasi data...",
    back_button: "Kembali",
  },
  CheckoutFailed: {
    title: "Pembayaran Gagal",
    description: "Maaf, transaksi Anda tidak dapat diproses atau dibatalkan. Jangan khawatir, saldo Anda belum terpotong.",
    order_details: "Detail Pesanan",
    ai_package: "Paket Top Up AI",
    limit_package: "Paket Limit",
    messages: "Pesan",
    credits: "Kredit",
    status: "Status: Belum Dibayar / Kadaluarsa",
    retry_button: "Coba Bayar Lagi",
    dashboard_button: "Ke Dashboard",
    need_help: "Butuh bantuan?",
    contact_cs: "Hubungi CS kami"
  },
  ComponentOrder: {
    perubahan_dibatalkan: "Perubahan urutan dibatalkan",
    tidak_ada_data_disimpan: "Tidak ada data yang dapat disimpan",
    komponen_baru: "Komponen Baru",
    belum_dapat_diubah: "Komponen baru belum dapat diubah visibilitasnya",
    dihapus_dari_sesi: "dihapus dari sesi ini",
    box_tidak_ditemukan: "Box tidak ditemukan",
    pilih_dahulu: "Pilih komponen terlebih dahulu",
    tambah_box: "Tambah Box",
    simpan_susunan: "Simpan Susunan",
    tambah_komponen_ke: "Tambah Komponen ke",
    tambah_komponen_di_atas: "Tambah Komponen di Atas",
    tambah_komponen_di_bawah: "Tambah Komponen di Bawah",
    pilih_komponen_baru: "Pilih Komponen Baru",
    pilih_component: "Pilih Component",
    cari_komponen: "Cari komponen...",
    tidak_ditemukan: "Komponen tidak ditemukan.",
    tambah_komponen: "Tambah Component",
    hapus_komponen: "Hapus Komponen",
    hapus_komponen_desc: "Hapus komponen",
    dari_box_desc: "dari box? Tindakan ini tidak dapat dibatalkan.",
    hapus_komponen_default: "Hapus komponen ini dari box? Tindakan ini tidak dapat dibatalkan.",
    hapus_box: "Hapus Box",
    hapus_desc: "Hapus",
    tidak_dapat_dibatalkan: "Tindakan ini tidak dapat dibatalkan.",
    hapus_box_default: "Hapus box ini? Tindakan ini tidak dapat dibatalkan.",
    bahasa: "Bahasa",
    bahasa_default: "Bahasa Default",
    belum_ada_terjemahan: "Belum ada terjemahan",
    tambah_terjemahan_baru: "Tambah Terjemahan Baru",
    kelola_bahasa: "Kelola Terjemahan Bahasa",
    belum_ada_terjemahan_desc: "Belum ada bahasa terjemahan yang ditambahkan",
    pilih_bahasa: "Pilih bahasa",
    semua_bahasa_ditambahkan: "Semua bahasa sudah ditambahkan",
    hapus_bahasa: "Hapus Bahasa",
    hapus_bahasa_desc: "Hapus terjemahan bahasa",
    tampilkan_komponen: "Tampilkan Komponen",
    komponen_disembunyikan: "Komponen ini disembunyikan di preview",
    smart_localization: "Smart Localization",
    rekomendasi_bahasa_default: "Rekomendasi: Selesaikan dulu bahasa default",
    ketik_pilih_bahasa: "Ketik atau pilih bahasa...",
    buat_baru: "Buat Baru",
    custom_label: "Custom",
    tidak_ada_bahasa_di_daftar: 'Tidak ada bahasa "{query}" di daftar',
    bahasa_sudah_ditambahkan: "Bahasa ini sudah ditambahkan",
    bahasa_sedang_diterjemahkan: "Bahasa ini masih dalam proses diterjemahkan, konten mungkin belum lengkap",
    tidak_ada_bahasa_lain: "Tidak ada bahasa lain di daftar",
    smart_localization_desc_before: "Lengkapi teks bahasa default terlebih dahulu. Bahasa dari daftar akan",
    smart_localization_desc_bold_auto: "diterjemahkan otomatis",
    smart_localization_desc_middle: "dan dapat diubah per bahasa, bahasa",
    smart_localization_desc_bold_custom: "custom",
    smart_localization_desc_after: "tidak diterjemahkan otomatis.",
    lang_en: "Inggris",
    lang_ko: "Korea",
    lang_zh: "Mandarin",
    lang_ar: "Arab",
    lang_id: "Indonesia",
    lang_ms: "Melayu",
    lang_ja: "Jepang",
    lang_th: "Thailand",
    lang_vi: "Vietnam",
    lang_hi: "Hindi",
    lang_es: "Spanyol",
    lang_fr: "Prancis",
    lang_de: "Jerman",
    lang_nl: "Belanda",
    lang_pt: "Portugis",
    lang_ru: "Rusia",
  },
  Payment: {
    success_title: "Pembayaran Berhasil",
    success_desc: "Selamat! Pembayaran Anda sudah berhasil tervalidasi.",
  },
  Vendor: {
    nomor_identitas: "Nomor Identitas (KTP/Passport)",
    placeholder_identitas: "Contoh: 5101... atau A1234...",
    err_identitas: "Nomor identitas minimal 5 karakter",
    identitas: "Identitas",
    bisnis: "Bisnis",
    kontak_sosial: "Kontak & Sosial",
    portfolio_submit: "Portfolio + Submit",
    form_bisnis_coming_soon: "Form Bisnis (Coming Soon)",
    form_kontak_coming_soon: "Form Kontak (Coming Soon)",
    form_portfolio_coming_soon: "Form Portfolio (Coming Soon)",
    simpan_draft: "Simpan draft",
    lanjut_ke: "Lanjut ke",
    kirim_pendaftaran: "Kirim Pendaftaran",
    verifikasi_identitas_title: "Verifikasi identitas pemilik bisnis.",
    data_bersifat: "Data ini bersifat",
    privat: "privat",
    verifikasi_identitas_desc: "dan hanya dilihat tim admin Elynk untuk verifikasi. Tidak akan tampil ke publik.",
    nama_lengkap_ktp: "Nama Lengkap (sesuai KTP)",
    contoh_nama: "Contoh: Anton Wijaya",
    tanggal_lahir: "Tanggal Lahir",
    nomor_ktp_nik: "Nomor KTP / NIK",
    disimpan_terenkripsi: "Disimpan terenkripsi",
    jenis_kelamin: "Jenis Kelamin",
    laki_laki: "Laki-laki",
    perempuan: "Perempuan",
    alamat_ktp: "Alamat sesuai KTP",
    placeholder_alamat: "Jl. Raya Kerobokan No. 88, Kuta Utara, Badung, Bali 80361",
    daftar_sebagai_vendor: "Daftar sebagai Vendor",
    lengkapi_data_bisnis: "Lengkapi data bisnis Anda untuk mulai bergabung di ekosistem Elynk.",
    nama_bisnis: "Nama Bisnis / Brand",
    tahun_berdiri: "Tahun Berdiri",
    kategori_bisnis: "Kategori Bisnis Utama",
    pilih_min_1: "Pilih min 1, dapat multi-select",
    deskripsi_bisnis: "Deskripsi Bisnis",
    min_100_karakter: "Min 100 karakter",
    provinsi_utama: "Provinsi Utama",
    kota_operasi: "Kota / Kabupaten Operasi",
    harga_mulai: "Harga Mulai Dari (IDR)",
    harga_maksimal: "Harga Maksimal (IDR)",
    logo_bisnis: "Logo Bisnis",
    banner_bisnis: "Foto Banner / Header",
    klik_atau_drop: "Klik atau drop file",
    kembali: "Kembali",
    contoh_provinsi: "Contoh: DKI Jakarta",
    contoh_kota: "Contoh: Jakarta Selatan, Bandung",
    placeholder_deskripsi: "Jelaskan secara singkat mengenai bisnis Anda...",
    info_kontak_publik: "Kontak ini akan tampil di profil publik Anda setelah disetujui. Pastikan WhatsApp aktif - calon client akan menghubungi melalui nomor ini.",
    kontak_utama: "Kontak Utama",
    no_whatsapp: "Nomor WhatsApp Bisnis",
    email_bisnis: "Email Bisnis",
    format_internasional: "Format internasional - akan diverifikasi via OTP",
    berbeda_email_login: "Berbeda dari email login bila perlu",
    telepon_sekunder: "Nomor Telepon Sekunder",
    jam_operasional: "Jam Operasional",
    opsional: "opsional",
    alamat_kantor: "Alamat Kantor / Studio",
    alamat_lengkap: "Alamat Lengkap",
    kode_pos: "Kode Pos",
    pin_lokasi: "Pin Lokasi (Google Maps)",
    drag_pin: "Drag pin untuk koreksi - opsional tapi disarankan",
    sosmed_website: "Sosial Media & Website",
    tambah: "+ Tambah",
    pilih_jenis: "Pilih jenis",
    username_url: "Username atau URL",
    rekening_bank: "Rekening Bank",
    opsional_privat: "(opsional - tidak tampil publik)",
    bank: "Bank",
    no_rekening: "Nomor Rekening",
    nama_pemilik: "Nama Pemilik",
    keperluan_transaksi: "Diperlukan untuk fitur transaksi/marketplace di masa mendatang",
    provinsi: "Provinsi",
    kota_kab: "Kota / Kab.",
    pilih_bank: "Pilih Bank",
    contoh_jam_operasional: "Senin - Sabtu : 09.00 - 18.00 WIB",
    portfolio_awal: "Portfolio Awal",
    info_portfolio: "Unggah minimal 1 portfolio sebagai bukti karya nyata Anda.",
    judul_portfolio: "Judul Portfolio / Project",
    kategori_portfolio: "Kategori",
    tanggal_event: "Tanggal Event",
    lokasi_event: "Lokasi Event",
    foto_portfolio: "Foto Portfolio",
    persetujuan_submit: "Persetujuan & Submit Pengajuan",
    info_review_admin: "Tim admin Elynk akan mereview pengajuan Anda dalam 2x24 jam kerja. Notifikasi keputusan akan dikirim via email.",
    setuju_snk: "Saya menyetujui Syarat & Ketentuan platform Elynk.co",
    setuju_data_benar: "Saya menyatakan semua data yang diberikan benar dan dapat dipertanggungjawabkan",
    setuju_banned: "Saya memahami Elynk berhak menolak/menangguhkan akun jika terbukti melanggar",
    setuju_moderasi: "Saya menyetujui kebijakan moderasi konten produk oleh admin",
    penting: "Penting",
    deskripsi_portfolio: "Deskripsi",
    maks_80_karakter: "Maks 80 karakter",
    drag_foto: "Drag foto ke sini",
    klik_pilih_foto: "atau klik untuk pilih • min 1, maks 20 foto",
    info_penting: "Jika pengajuan ditolak, akun Anda tidak dapat mengajukan ulang sebagai vendor. Pastikan semua data lengkap dan akurat sebelum submit.",
    sukses_judul: "Pendaftaran Berhasil Dikirim!",
    sukses_deskripsi: "Terima kasih telah mendaftar di Elynk.co. Saat ini profil Anda sedang dalam proses kurasi oleh tim admin kami.",
    sukses_estimasi: "Proses ini biasanya memakan waktu maksimal 2x24 jam kerja. Kami akan mengirimkan notifikasi melalui email setelah profil Anda disetujui.",
    tombol_dashboard: "Kembali ke Dashboard",
    estimasi_waktu: "Estimasi Waktu Tunggu",
    mengirim: "Mengirim Data",
    err_judul_portfolio: "Judul portfolio wajib diisi (maks 80 karakter)",
    err_foto_portfolio: "Wajib upload minimal 1 foto portfolio",
    err_wajib_centang: "Anda wajib menyetujui pernyataan ini",
    err_url_wajib: "Wajib diisi",
    err_nama_lengkap: "Nama lengkap minimal 3 karakter",
    err_tanggal_lahir: "Tanggal lahir wajib diisi",
    err_nik: "NIK KTP harus berupa 16 digit angka",
    err_jenis_kelamin: "Pilih jenis kelamin",
    err_alamat: "Alamat terlalu pendek, mohon lengkapi",
    err_nama_bisnis: "Nama bisnis minimal 3 karakter",
    err_tahun_berdiri: "Tahun berdiri tidak valid",
    err_kategori: "Pilih minimal 1 kategori bisnis",
    err_deskripsi: "Deskripsi bisnis minimal 100 karakter",
    err_provinsi: "Pilih provinsi utama",
    err_kota: "Pilih minimal 1 kota operasi",
    err_harga_mulai: "Harga mulai dari wajib diisi",
    err_whatsapp: "Nomor WhatsApp tidak valid",
    err_email: "Format email tidak valid",
    err_sosmed: "Minimal 1 sosial media atau website",
    draft_dimuat: "Draft sebelumnya berhasil dimuat. (File gambar perlu diunggah ulang)",
    draft_disimpan: "Draft berhasil disimpan di browser Anda!",
    memuat: "Memeriksa Status"
  },
  VendorSidebar: {
    menu_title: "Menu Utama",
    settings_title: "Konfigurasi",
    dashboard: "Dashboard",
    business_profile: "Profil Bisnis",
    products: "Produk Saya",
    portfolio: "Portfolio",
    reviews: "Ulasan Pelanggan",
    analytics: "Analistik",
    settings: "Pengaturan Akun",
    view_public_profile: "Lihat Profil Publik",
    back_to_admin: "Kembali ke Admin",
    active: "Aktif",
    pending: "Menunggu Persetujuan",
    paused: "Dihentikan Sementara"
  },
  VendorDashboard: {
    welcome_back: "Selamat datang kembali,",
    btn_portfolio: "Portfolio",
    btn_new_product: "Produk Baru",
    stat_pageview: "Pageviews (30 Hari)",
    stat_unique_visitors: "Pengunjung Unik",
    stat_clicks: "Klik Kontak",
    stat_rating: "Rata-rata Rating",
    stat_products: "Produk Aktif",
    default_visitor_breakdown: "0% guest · 0% login",
    chart_title: "Grafik Trafik & Interaksi",
    chart_subtitle: "Periode 30 Hari Terakhir",
    tab_pageview: "Pageview",
    tab_clicks: "Klik Kontak",
    grade_title: "Grade Vendor",
    suggestions_title: "Saran untuk Anda",
    no_suggestions: "Tidak ada saran saat ini.",
    view_grade_history: "Lihat riwayat grade →",
    reminder_portfolio_title: "Reminder Portfolio",
    btn_upload_now: "+ Upload sekarang",
    contact_analysis_title: "Analisis Saluran Kontak",
    no_contact_data: "Belum ada data klik kontak periode ini.",
    top_products_title: "Top Produk Terpopuler",
    views: "views",
    no_top_products: "Belum ada data produk terpopuler",
    traffic_sources_title: "Sumber Kunjungan Utama",
    no_traffic_sources: "Belum ada data sumber kunjungan",
    latest_product_status_title: "Status Produk Terkini",
    no_registered_products: "Belum ada produk terdaftar",
    clicks: "klik",
    recent_activities_title: "Aktivitas Terbaru",
    no_recent_activities: "Belum ada aktivitas terbaru",
    error_load_title: "Gagal Memuat Dashboard",
    btn_reload: "Muat Ulang Halaman",
    error_no_data: "Data dashboard tidak tersedia",
    error_network: "Terjadi kesalahan jaringan saat memuat data."
  },
  ProductForm: {
    basic_info_title: "Informasi Dasar",
    label_title: "Judul Produk / Paket",
    max_chars: "Maks",
    characters: "karakter",
    label_category: "Kategori",
    cat_photographer: "Fotografer",
    cat_mua: "Make Up Artist",
    cat_venue: "Venue",
    cat_entertainment: "Entertainment",
    label_status: "Status Ketersediaan",
    status_active: "Aktif",
    status_unavailable: "Tidak Tersedia",
    label_description: "Deskripsi Produk",
    prompt_link: "Masukkan URL Link (contoh: https://google.com):",
    description_hint: "Min 150 karakter · rich text editor",
    price_title: "Harga",
    label_price_type: "Tipe Harga",
    price_from: "Mulai dari",
    price_fixed: "Fixed",
    price_contact: "Hubungi kami",
    label_price_value: "Harga (IDR)",
    sidebar_action_title: "Aksi",
    btn_submit_review: "Submit untuk review",
    btn_save_draft: "Simpan draft",
    btn_preview: "Preview",
    info_after_submit_bold: "Setelah submit:",
    info_after_submit_desc: "Produk masuk antrian admin. Estimasi review 2x24 jam kerja. Versi lama tetap tampil ke publik selama review berjalan.",
    sidebar_checklist_title: "Checklist Kelengkapan",
    check_title_cat: "Judul",
    check_desc: "Deskripsi (320 kar.)",
    check_price: "Harga",
    check_images: "3 gambar diupload",
    check_list: "Daftar termasuk/tidak",
    check_faq: "FAQ (rekomendasi)",
    check_tags: "Tag (rekomendasi)",
    media_title: "Gambar Produk",
    photo: "foto",
    label_primary: "utama",
    media_hint: "Min 1, maks 10 · drag-and-drop untuk reorder",
    inclusions_title: "Yang Termasuk & Tidak Termasuk",
    label_included: "Termasuk dalam paket",
    label_excluded: "Tidak Termasuk",
    btn_add_item: "Tambah item",
    label_optional: "opsional",
    btn_add_faq: "Tambah FAQ",
    label_question: "Pertanyaan",
    label_answer: "Jawaban",
    label_estimate: "Estimasi Pengerjaan",
    label_tags: "Tag / Keyword",
    draft_saved_success: "Draft berhasil disimpan secara lokal!",
    available_slots: "Slot tersedia",
    of: "dari",
    create_new_product: "Buat Produk Baru",
    draft_not_submitted: "Draft · belum disubmit",
    draft_last_update: "Update terakhir:",
    btn_back_to_list: "Kembali ke Daftar Produk",
    edit_product_id: "ID Produk:",
    edit_title: "Update Paket Layanan",
    edit_mode_badge: "Mode Edit / Pembaruan",
  },
  Profile: {
    title: "Profil Bisnis",
    completion_prefix: "Kelengkapan profil:",
    completion_suffix: "berkontribusi 57/60 ke skor grade",
    btn_preview: "Preview profil publik",
    btn_save: "Simpan perubahan",
    tab_general: "Umum",
    tab_area: "Area Layanan",
    tab_social: "Sosial Media",
    score_title: "Skor Kelengkapan",
    check_logo_banner: "Logo & banner",
    check_desc: "Deskripsi (142 kar)",
    check_category: "Kategori & area",
    check_price: "Harga rentang",
    check_social: "Min 1 sosmed",
    check_tiktok: "TikTok (opsional)",
    info_title: "Perubahan Langsung Tayang",
    info_desc_1: "Update informasi bisnis (deskripsi, harga, banner, kategori, area, sosmed)",
    info_desc_bold: "tidak memerlukan approval admin",
    info_desc_2: "perubahan langsung tayang di profil publik setelah disimpan.",
    media_title: "Banner & Logo",
    btn_change_banner: "Ganti banner",
    logo_title: "Logo Bisnis",
    btn_upload_new: "Upload baru",
    btn_delete: "Hapus",
    basic_info_title: "Informasi Dasar",
    label_biz_name: "Nama Bisnis",
    label_category: "Kategori Bisnis",
    btn_add_category: "Tambah kategori",
    label_desc: "Deskripsi Bisnis",
    label_year: "Tahun Berdiri",
    label_slug: "Slug URL",
    pricing_title: "Harga & Layanan",
    label_price_min: "Harga Mulai Dari",
    label_price_max: "Harga Maksimal",
    service_prov_title: "Provinsi Operasional",
    service_prov_desc: "Pilih satu atau lebih provinsi tempat Anda beroperasi.",
    btn_add_prov: "Tambah provinsi",
    service_quick_add_prov: "Tambah cepat (provinsi populer)",
    service_city_title: "Kota / Kabupaten Layanan",
    service_city_desc: "Kota yang Anda layani. Filter pencarian client akan mengikuti daftar ini.",
    btn_add_city: "Tambah kota",
    service_quick_add_city: "Tambah cepat (kota populer)",
    service_address_title: "Alamat Kantor / Studio",
    service_address_desc: "Alamat ini tidak tampil di profil publik, hanya untuk verifikasi internal.",
    label_full_address: "Alamat Lengkap",
    label_city: "Kota",
    label_postal: "Kode Pos",
    contact_title: "Kontak Utama",
    contact_desc: "Tampil di profil publik · dilindungi gated contact (hanya user login bisa lihat).",
    label_wa: "Nomor WhatsApp Bisnis",
    wa_note: "Mengubah nomor membutuhkan verifikasi ulang via OTP",
    label_email: "Email Bisnis",
    label_hours: "Jam Operasional",
    social_title: "Sosial Media & Website",
    social_desc: "Tampil sebagai tombol di sidebar profil publik · min 1, maks 6.",
    btn_add_link: "Tambah link",
    preview_title: "Preview di Profil Publik",
    preview_subtitle: "SOSIAL MEDIA",
    badge_verified: "Terverifikasi",
    badge_valid: "valid",
    badge_optional: "opsional",
    empty_links: "Belum ada link yang valid...",
  },
  Product: {
    title: "Produk & Paket Layanan",
    subtitle_total: "Total",
    subtitle_products: "produk - sisa",
    subtitle_slots: "slot",
    btn_create: "Buat Produk Baru",
    status_live: "Live",
    desc_live: "tampil ke publik",
    status_pending: "Pending Review",
    desc_pending: "menunggu admin",
    status_revision: "Perlu Revisi",
    desc_revision: "aksi diperlukan",
    status_draft: "Draft / Inactive",
    desc_draft: "belum disubmit",
    tab_all: "Semua",
    tab_live: "Live",
    tab_pending: "Pending",
    tab_revision: "Revisi",
    tab_draft: "Draft",
    search_placeholder: "Cari produk...",
    sort_label: "Urutkan:",
    sort_newest: "Terbaru",
    sort_oldest: "Terlama",
    th_product: "PRODUK",
    th_status: "STATUS",
    th_price: "HARGA",
    th_rating: "RATING",
    th_view: "VIEW / KLIK",
    th_update: "UPDATE",
    action_edit: "Edit",
    action_view: "Lihat",
    action_fix: "Perbaiki",
    action_continue: "Lanjutkan",
    btn_prev: "Sebelumnya",
    btn_next: "Selanjutnya",
    pagination_showing: "Menampilkan",
    pagination_of: "dari"
  },
  ProductDetail: {
    title: "Detail Produk",
    description: "Pratinjau lengkap informasi produk dan paket layanan Anda.",
    loading: "Memuat detail portfolio...",
    starts_from: "Mulai ",
    estimation: "Estimasi pengerjaan:",
    primary: "Utama",
    description_title: "Deskripsi",
    included: "Termasuk",
    excluded: "Tidak Termasuk",
    btn_close: "Tutup",
  },
  ProductTable: {
    col_product: "Produk",
    col_status: "Status",
    col_price: "Harga",
    col_update: "Update",
    btn_view: "Lihat",
    empty_title: "Belum ada produk",
    empty_desc: "Data produk tidak ditemukan atau belum dibuat.",
    working_days: "hari kerja",
    no_estimation: "Estimasi tidak diatur",
    btn_edit: "Edit Produk",
    btn_delete: "Hapus",
  },
  Review: {
    title: "Review dari Client",
    subtitle: "Balas review untuk membangun kepercayaan client baru. Maks 1 balasan per review.",
    rating_active: "review aktif",
    dist_title: "Distribusi Rating",
    filter_title: "Filter",
    filter_unreplied: "Belum dibalas",
    filter_5star: "5★ saja",
    filter_3star_below: "≤ 3★ (perlu perhatian)",
    filter_has_photo: "Ada foto bukti",
    filter_reported: "Dilaporkan",
    tab_all: "Semua",
    tab_unreplied: "Belum dibalas",
    tab_1to3: "1-3★",
    sort_label: "Urutkan:",
    sort_newest: "Terbaru",
    sort_oldest: "Terlama",
    verified_client: "verified client",
    on_package: "pada",
    reply_title: "BALASAN ANDA",
    replied_on: "Dibalas",
    btn_edit: "Edit",
    reply_form_title: "Balas review ini",
    reply_form_limit: "(maks 1 balasan)",
    reply_placeholder: "Tulis balasan Anda — ucapkan terima kasih, klarifikasi, atau permintaan maaf jika diperlukan...",
    btn_report: "Laporkan review",
    btn_later: "Nanti",
    btn_send: "Kirim balasan",
    reported_badge: "Dilaporkan",
    report_status: "Status laporan:",
    report_waiting: "Menunggu keputusan admin",
    reported_on: "Dilaporkan pada",
    report_reason: "alasan:",
    load_more: "Muat {count} review lainnya ↓",
    report_status_title: "Review Dalam Peninjauan Admin",
    report_reason_label: "Alasan laporan:",
    reply_later_msg: "Anda menandai ulasan ini untuk dibalas nanti.",
    reply_now_btn: "Tulis balasan sekarang",
  },
  Analytics: {
    title: "Analytics",
    subtitle: "Hanya menampilkan data milik Anda · diagregasi & anonim",
    btn_export: "Export CSV",
    filter_7d: "7 hari",
    filter_30d: "30 hari",
    filter_3m: "3 bulan",
    filter_1y: "Tahun ini",
    score_pageview: "Total Pageview",
    score_click: "Klik Kontak",
    score_visitor: "Unique Visitor",
    score_conversion: "Conversion ke Kontak",
    from_last_period: "dari periode lalu",
    chart_traffic: "Trafik Profil — 30 Hari",
    chart_breakdown: "Breakdown Klik Kontak",
    legend_pageview: "Pageview",
    legend_click: "Klik Kontak",
    list_products: "Produk Paling Dilihat",
    list_sources: "Asal Trafik",
    th_user: "USER",
    th_product: "PRODUK",
    th_type: "TIPE",
    th_time: "WAKTU",
    table_title: "Klik Kontak Terbaru",
    table_subtitle: "User yang klik tombol Hubungi · disimpan untuk analytics",
    btn_view_all: "Lihat semua {count} klik →"
  },
  VendorSettingsPage: {
    title: "Akun",
    subtitle: "Pengaturan email login & informasi akun",
    menu_akun: "Akun",
    menu_keamanan: "Keamanan",
    menu_notifikasi: "Notifikasi",
    menu_privasi: "Privasi",
    menu_tim: "Tim & Akses",
    menu_zona: "Zona Berbahaya",
    section_identitas: "Email & Identitas",
    lbl_email: "Email Login",
    lbl_phone: "Nomor HP Login",
    lbl_lang: "Bahasa",
    lbl_timezone: "Zona Waktu",
    btn_ubah_email: "Ubah email",
    btn_ubah: "Ubah",
    badge_verified: "Terverifikasi",
    section_keamanan: "Keamanan",
    lbl_password: "Password",
    desc_password: "Terakhir diubah 3 bulan lalu",
    btn_ubah_password: "Ubah password",
    lbl_2fa: "2-Step Verification",
    desc_2fa: "Tambah lapis keamanan via OTP WhatsApp",
    badge_inactive: "Belum aktif",
    btn_activate: "Aktifkan",
    lbl_session: "Session Aktif",
    desc_session: "3 perangkat sedang login",
    btn_manage_session: "Kelola sesi",
    section_notif: "Preferensi Notifikasi",
    th_jenis: "JENIS",
    notif_1: "Hasil review produk oleh admin",
    notif_1_desc: "Approve / revisi / reject",
    notif_2: "Review baru masuk",
    notif_2_desc: "Dari client di produk Anda",
    notif_3: "Perubahan grade",
    notif_3_desc: "Naik atau turun grade vendor",
    notif_4: "Reminder portfolio",
    notif_4_desc: "Hari ke-20 & ke-27 sejak upload terakhir",
    notif_5: "Digest harian kontak",
    notif_5_desc: "Ringkasan klik kontak harian",
    notif_6: "Tips & info dari Elynk",
    notif_6_desc: "Promosi, update fitur, edukasi",
    section_zona: "Zona Berbahaya",
    desc_zona: "Aksi di bawah ini bersifat permanen atau membutuhkan koordinasi dengan admin Elynk.",
    lbl_pause: "Pause Akun Vendor",
    desc_pause: "Profil tetap ada tapi tidak tampil di direktori. Bisa diaktifkan kembali kapan saja.",
    btn_pause: "Pause",
    lbl_delete: "Hapus Akun Vendor",
    desc_delete: "Soft delete - data disimpan 90 hari sebelum dihapus permanen.",
    btn_delete: "Hapus akun"
  },
  BackgroundBoxForm: {
    tambah_gambar: "Tambah Gambar",
    ganti_gambar: "Ganti Gambar",
    hapus_video: "Hapus Video",
    tambah_video: "Tambah Video",
    ganti_video: "Ganti Video",
    foto_wajib_untuk_video: "Tambahkan foto background terlebih dahulu sebelum menggunakan video",
    simpan_perubahan: "Simpan Perubahan",
    modal_ganti_gambar: "Ganti Gambar",
    modal_tambah_gambar: "Tambah Gambar",
    modal_tambah_video: "Tambah Video",
    modal_ganti_video: "Ganti Video",
    video_latar: "Video Latar",
    video_tersimpan: "Video tersimpan",
    mulai_menit: "Mulai (mm:ss)",
    selesai_menit: "Selesai (mm:ss)",
    keterangan_menit: "Contoh:",
    keterangan_menit_satuan: "= {n} menit {s} detik.",
    keterangan_selesai_kosong: "Kosongkan Selesai ({placeholder}) untuk putar sampai akhir.",
    gunakan_link: "Gunakan Link Ini",
    placeholder_youtube: "https://youtube.com/watch?v=...",
    tab_youtube: "YouTube",
    tab_upload: "Upload File",
    drop_video: "Lepaskan video di sini",
    drag_or_click: "Seret atau klik untuk mengunggah video",
    format_video: "MP4, MOV, WebM",
    mengunggah: "Mengunggah…",
    berhasil_unggah: "Video berhasil diunggah — klik Simpan Perubahan untuk menyimpan",
    gagal_url_video: "Gagal mendapatkan URL video",
    link_youtube_tidak_valid: "Link yang dimasukkan bukan link YouTube yang valid",
    ukuran_video_terlalu_besar: "Ukuran video maksimal 20MB",
    format_video_tidak_didukung: "Format video tidak didukung"
  },
  StyleEditor: {
    reset_confirm_title: "Reset Style Komponen Ini?",
    reset_confirm_desc: "Kembalikan style komponen {name} ini ke pengaturan awal (kosong)? Perubahan yang sudah Anda simpan khusus untuk komponen ini akan dihapus. Komponen lain tidak akan terpengaruh.",
    reset_confirm_cancel: "Batal",
    reset_confirm_button: "Ya, Reset",
    reset_loading_button: "Mereset...",
    reset_button: "Reset",
    reset_no_invitation: "ID Undangan tidak ditemukan",
    empty_title: "Style Editor",
    empty_desc: "Klik area komponen pada pratinjau untuk mulai mengedit desainnya.",
    label_component: "Komponen: {name}",
    label_type: "Tipe: {type}",
    copy_json: "Salin JSON Style",
    save_style: "Simpan Style",
    save_changes: "Simpan Perubahan",
    color_text: "Warna Teks",
    color_background: "Warna Background",
    color_border: "Warna Border",
  },
  BoxEditor: {
    slot_saved_as: "Property akan disimpan sebagai",
    title: "Box Editor",
    undo: "Urungkan (Ctrl+Z)",
    redo: "Ulangi (Ctrl+Shift+Z)",
    back_to_editor: "Kembali ke Editor",
    edit_via_json: "Edit via JSON",
    load_json: "Muat JSON",
    load_json_title: "Muat dari JSON",
    global_slider: "Slider (Level Atas)",
    global_slider_hint: "(Aktifkan slider untuk seluruh box)",
    cancel: "Batal",
    save: "Simpan",
    saving: "Menyimpan...",
    done: "Selesai",
    delete: "Hapus",
    deleting: "Menghapus...",
    confirm_leave: "Perubahan box belum disimpan. Tetap keluar?",
    confirm_cancel: "Batalkan semua perubahan box yang belum disimpan?",
    toast_saved: "Box berhasil disimpan",
    toast_save_failed: "Gagal menyimpan box",
    layer_title: "Layer",
    layer_hint: "(visibilitas di preview)",
    layer_overlay: "Overlay",
    layer_overlay_hint: "isi komponen",
    layer_ornaments: "Ornaments",
    layer_ornaments_hint: "hiasan",
    layer_base: "Base",
    layer_base_hint: "latar",
    layer_show: "Tampilkan {name}",
    layer_hide: "Sembunyikan {name}",
    focus_ornament: "Fokus edit ornament",
    focus_ornament_done: "Selesai edit ornament",
    show_all: "Tampilkan semua",
    layer_help: "Klik ornament di preview untuk memilih, lalu drag / resize / putar. Esc untuk batal pilih.",
    show_in_preview: "Tampilkan di preview",
    hide_in_preview: "Sembunyikan di preview",
    properties_count: "{count} properti",
    use_images: "Gunakan Gambar",
    use_images_hint: "(Aktifkan daftar gambar latar)",
    no_images: "Belum ada gambar.",
    image_url_placeholder: "/path/ke/gambar.jpg atau URL lengkap",
    add_image_url: "Tambah URL Gambar",
    is_slider: "Slider",
    is_slider_hint: "(Aktifkan slider untuk {name})",
    col_property: "Properti",
    col_value: "Nilai",
    no_properties: "Belum ada properti.",
    add_section: "Tambah {name}",
    property_placeholder: "properti",
    value_placeholder: "nilai",
    ornaments: "Ornaments",
    items_count: "{count} item",
    no_ornaments: "Belum ada ornament.",
    add_ornament: "Tambah ornament",
    delete_ornament: "Hapus ornament",
    selected: "dipilih",
    styles_count: "{count} style",
    type: "Tipe",
    url_path: "URL / path",
    choose_image: "Pilih gambar",
    wrapper_styles: "Style Wrapper",
    add_style: "Tambah style",
    no_wrapper_styles: "Belum ada style wrapper.",
    element_tree: "Pohon Elemen",
    nodes_count: "{count} node",
    selected_node: " • dipilih {type}",
    add_root_element: "Tambah elemen root",
    no_nodes: "Belum ada node. Tambahkan elemen root lalu tambah child seperti di component builder.",
    nodes: "Node",
    pick_node: "Pilih node di panel kiri untuk mulai mengedit props, style, dan child element.",
    svg_code: "Kode SVG",
    svg_invalid_prefix: "Harus diawali",
    svg_invalid_middle: "dan diakhiri",
    animation_on: "🎬 animasi",
    animation_add: "+ animasi",
    preview_animation: "Pratinjau animasi",
    node: "Node",
    node_type: "tipe",
    add_child: "Tambah Child",
    raw_svg: "Raw SVG",
    raw_svg_hint: "tempel <svg>...</svg>",
    raw_svg_note_prefix: "Nilai ini disimpan ke prop",
    raw_svg_note_suffix: "untuk dirender sebagai SVG mentah.",
    props: "Props",
    add_prop: "+ prop",
    no_props: "Belum ada props.",
    key_placeholder: "key",
    styles: "Style",
    no_styles: "Belum ada style.",
    rotate: "Putar",
    choose_token: "-- pilih token --",
    choose_from_media_placeholder: "Pilih dari media...",
    free_value_placeholder: "nilai bebas...",
    switch_to_text: "Ganti ke teks bebas",
    switch_to_token: "Ganti ke token",
    choose_from_media: "Pilih dari media",
    json_title: "Muat Struktur JSON",
    json_desc_prefix: "Tempel",
    json_desc_suffix: "dari API untuk dimuat ke editor.",
    format: "Format",
    clear: "Bersihkan",
    json_stats: "{lines} baris · {chars} karakter",
    json_placeholder: "Masukkan JSON di sini...",
    json_loaded: "JSON berhasil dimuat ke editor!",
    load_to_editor: "Muat ke Editor",
    json_must_be_object: "JSON harus berupa object, bukan array.",
    json_invalid: "JSON tidak valid.",
    json_format_failed: "Tidak bisa format — JSON tidak valid.",
    anim_title: "Animasi Node",
    anim_choose_style: "Pilih Gaya Animasi",
    preview: "Pratinjau",
    replay: "▶ Putar ulang",
    duration: "Durasi",
    easing: "Gaya gerak",
    anim_pick_hint: "Pilih salah satu gaya animasi di atas untuk melanjutkan",
    remove_animation: "Hapus Animasi",
    apply: "Terapkan",
    ease_smooth: "Halus",
    ease_fast_start: "Awal cepat",
    ease_overshoot: "Melewati lalu kembali",
    ease_bounce: "Memantul",
    ease_elastic: "Elastis",
    ease_sine: "Sinus",
    ease_linear: "Linear",
    add_style_title: "Tambah Style Property",
    tab_preset: "Preset",
    tab_custom: "Custom",
    slot_label: "Bagian yang di-style",
    custom_hint_prefix: "Isi property CSS secara manual (misal:",
    custom_hint_suffix: "dll)",
    custom_property_label: "Properti (CSS key)",
    custom_property_placeholder: "misal: letter-spacing",
    default_value: "Nilai Default",
    custom_value_placeholder: "misal: 0.05em",
    add_style_button: "+ Tambah Style",
    search_property: "Cari property... (misal: color, flex, margin)",
    no_matching_property: "Tidak ada property yang cocok",
    default_label: "default:",
    already_added: "✓ Sudah ditambahkan",
    cat_all: "Semua",
    cat_layout: "Layout",
    cat_background: "Latar",
    cat_spacing: "Jarak",
    cat_typography: "Tipografi",
    cat_border: "Border",
    cat_effects: "Efek",
    cat_animation: "Animasi",
    cat_position: "Posisi",
    cat_special: "Khusus",
    prop_desc_display: "Tipe box model elemen",
    prop_desc_flexDirection: "Arah sumbu flex container",
    prop_desc_alignItems: "Posisi item di sumbu silang",
    prop_desc_justifyContent: "Distribusi item di sumbu utama",
    prop_desc_width: "Lebar elemen",
    prop_desc_height: "Tinggi elemen",
    prop_desc_minHeight: "Tinggi minimum elemen",
    prop_desc_overflow: "Tampilan konten yang meluap",
    prop_desc_position: "Metode positioning elemen",
    prop_desc_zIndex: "Urutan tumpukan elemen (layer)",
    prop_desc_top: "Jarak dari tepi atas",
    prop_desc_left: "Jarak dari tepi kiri",
    prop_desc_right: "Jarak dari tepi kanan",
    prop_desc_bottom: "Jarak dari tepi bawah",
    prop_desc_background: "Properti shorthand untuk latar belakang",
    prop_desc_backgroundColor: "Warna latar belakang",
    prop_desc_backgroundImage: "Gambar latar belakang",
    prop_desc_backgroundSize: "Ukuran tampilan gambar latar",
    prop_desc_backgroundPosition: "Posisi gambar latar",
    prop_desc_margin: "Jarak di luar elemen (4 sisi)",
    prop_desc_padding: "Jarak di dalam elemen (4 sisi)",
    prop_desc_color: "Warna teks",
    prop_desc_fontSize: "Ukuran huruf",
    prop_desc_fontWeight: "Ketebalan huruf",
    prop_desc_textAlign: "Perataan teks horizontal",
    prop_desc_lineHeight: "Jarak antar baris teks",
    prop_desc_fontFamily: "Jenis font / tipografi elemen",
    prop_desc_borderRadius: "Lengkungan sudut elemen",
    prop_desc_border: "Garis tepi elemen",
    prop_desc_boxShadow: "Bayangan elemen",
    prop_desc_opacity: "Tingkat transparansi",
    prop_desc_transform: "Rotasi, skala, translasi",
    prop_desc_transition: "Animasi perubahan property",
    prop_desc_animation: "Animasi keyframe CSS",
    prop_desc_contain: "Gambar latar tidak meluap, menghasilkan background-size: contain",
    remove_token: "Hapus token",
    use_token: "Gunakan token {token}",
    side_top: "Atas",
    side_right: "Kanan",
    side_bottom: "Bawah",
    side_left: "Kiri",
    anim_custom: "Kustom",
    choose_animation: "Pilih Animasi",
    animation_placeholder: "misal: smoothSwing 5.5s infinite ease-in-out",
    select_placeholder: "Pilih...",
    font_theme: "Tema",
    font_heading: "Judul",
    font_sub: "Sub",
    font_description: "Deskripsi",
    bg_solid: "Warna solid",
    bg_linear: "Gradient linear",
    bg_radial: "Gradient radial",
    bg_image: "Gambar",
    bg_angle: "Sudut",
    bg_color_stops: "Titik warna",
    bg_add_stop: "Tambah titik",
    bg_shape: "Bentuk",
    bg_color: "Warna",
    bg_url: "URL",
    bg_size: "Ukuran",
    bg_position: "Posisi",
    bg_repeat: "Pengulangan",
    move_up: "Pindah ke atas",
    move_down: "Pindah ke bawah",
    delete_layer: "Hapus layer",
    no_layers: "Belum ada layer. Tambahkan gradient atau gambar di atas.",
    close_editor: "Tutup editor",
    edit_background: "Edit background",
    set_background: "Atur background",
    theme_color_variables: "Variable Warna Tema",
    pick_color: "Pilih Warna",
    default: "Default",
    color_primary: "Primer",
    color_secondary: "Sekunder",
    color_heading: "Judul",
    color_paragraph: "Paragraf",
    color_other: "Lainnya",
    media_title: "Pilih Media",
    ornament_tab: "Ornament",
    upload_ornament: "Upload Ornament",
    upload_ornament_title: "Upload Media Ornament",
    media_label: "Media",
    drop_here: "Lepas file di sini ...",
    drag_or_click: "Drag & drop gambar ke sini, atau klik untuk memilih",
    media_name: "Nama Media",
    uploading: "Mengupload...",
    upload: "Upload",
    invalid_file_type: "Hanya format .jpg, .jpeg, .png, .gif, dan .webp yang didukung.",
    media_name_required: "Nama media harus diisi.",
    media_name_too_long: "Nama media tidak boleh lebih dari 255 karakter.",
    search_ornament: "Cari ornament...",
    clear_search: "Hapus pencarian",
    delete_item: "Hapus {name}",
    ornament_load_failed: "Gagal memuat media ornament.",
    ornament_not_found: "Media ornament tidak ditemukan.",
    all_media_loaded: "Semua media sudah dimuat.",
    pick: "Pilih",
    delete_media_title: "Hapus Media Ornament",
    delete_media_confirm_prefix: "Yakin ingin menghapus",
    toast_upload_ok: "Media ornament berhasil diupload",
    toast_upload_failed: "Gagal mengupload media ornament",
    toast_delete_ok: "Media ornament berhasil dihapus",
    toast_delete_failed: "Gagal menghapus media ornament",
  },
}
export default id;